import React, { createContext, useState, useRef, useEffect, useContext } from 'react';
import { connect as connect$1, Provider } from 'react-redux';
import { combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { ActionCreator } from '@sendoutcards/core';
import isNumber from 'lodash/isNumber';
import { jsx, css, Global } from '@emotion/react';
import { Flex, Text, Div, Grid, GridItem, Image as Image$1, Accordion, HStack, Icon, IncrementSetting, useColorSwatch, Input, Spacer, Tabs, Tab, VStack, IconLink, QuantumColorPicker, Checkbox, List, ListItem, Pill, Sidebar, Section, Span, Tooltip, QuantumThemeWrapper, Drawer, Zoom, LoadingSpinner, Button } from '@sendoutcards/quantum-design-ui';
import equal from 'fast-deep-equal';
import ReactResizeDetector from 'react-resize-detector';
import AvatarEditor from 'react-avatar-editor';
import Moveable from 'react-moveable';
import useResizeObserver from 'use-resize-observer';
import { useMergeRefs } from 'use-callback-ref';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var selectImageScale = ActionCreator('SELECT_IMAGE_SCALE', function (scale) {
  return {
    scale: scale
  };
});
var removeImage = ActionCreator('REMOVE_IMAGE');
var selectElement = ActionCreator('SELECT_ELEMENT', function (activeElement, panelLocation, textStart, textEnd) {
  return {
    activeElement: activeElement,
    panelLocation: panelLocation,
    textStart: textStart,
    textEnd: textEnd
  };
});
var deselectElement = ActionCreator('DESELECT_ELEMENT');
var toggleElementDraggable = ActionCreator('TOGGLE_ELEMENT_DRAGGABLE');
var setCard = ActionCreator('SET_CARD', function (card) {
  return {
    card: card
  };
});
var openFacebookImageDrawer = ActionCreator('OPEN_FACEBOOK_IMAGE_DRAWER');
var clearCard = ActionCreator('CLEAR_CARD');
var setToolbarAction = ActionCreator('SET_TOOLBAR_ACTION', function (toolbarAction) {
  return {
    toolbarAction: toolbarAction
  };
});
var selectBackPanel = ActionCreator('SELECT_BACK_PANEL', function (layout) {
  return {
    layout: layout
  };
});
var updateCard = ActionCreator('UPDATE_CARD', function (card) {
  return {
    card: card
  };
});
var setPanelBackground = ActionCreator('SET_PANEL_BACKGROUND', function (color) {
  return {
    color: color
  };
});
var openFilterDrawer = ActionCreator('OPEN_FILTER_DRAWER');
var selectFilter = ActionCreator('SELECT_FILTER', function (filterName, url) {
  return {
    filterName: filterName,
    url: url
  };
});
var removeSpan = ActionCreator('REMOVE_SPAN');
var openBackgroundDrawer = ActionCreator('OPEN_BACKGROUND_DRAWER');
var addElement = ActionCreator('ADD_ELEMENT', function (elementType, isFullPanel) {
  return {
    elementType: elementType,
    isFullPanel: isFullPanel
  };
});
var disableSelectingElements = ActionCreator('DISABLE_SELECTING_ELEMENTS');
var enableSelectingElements = ActionCreator('ENABLE_SELECTING_ELEMENTS');
var updateElementSize = ActionCreator('UPDATE_ELEMENT_SIZE', function (elementLocation, width, height) {
  return {
    elementLocation: elementLocation,
    width: width,
    height: height
  };
});
var selectImagePosition = ActionCreator('SELECT_IMAGE_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateElementPosition = ActionCreator('UPDATE_ELEMENT_POSITION', function (elementLocation, x, y) {
  return {
    elementLocation: elementLocation,
    x: x,
    y: y
  };
});
var updateElementRotation = ActionCreator('UPDATE_ELEMENT_ROTATION', function (elementLocation, rotation) {
  return {
    elementLocation: elementLocation,
    rotation: rotation
  };
});
var selectImage = ActionCreator('SELECT_IMAGE', function (photo) {
  return {
    photo: photo
  };
});
var removeElement = ActionCreator('REMOVE_ELEMENT');
var selectLayoutToLoad = ActionCreator('SELECT_LAYOUT_TO_LOAD', function (layoutId) {
  return {
    layoutId: layoutId
  };
});
var selectFullBleed = ActionCreator('SELECT_FULL_BLEED', function (fullBleedLocation) {
  return {
    fullBleedLocation: fullBleedLocation
  };
});
var selectSinglePanel = ActionCreator('SELECT_SINGLE_PANEL', function (fullBleedLocation, panelLocation) {
  return {
    fullBleedLocation: fullBleedLocation,
    panelLocation: panelLocation
  };
});
var selectLayout = ActionCreator('SELECT_LAYOUT', function (layout) {
  return {
    layout: layout
  };
});
var loadedCard = ActionCreator('LOADED_CARD', function (card) {
  return {
    card: card
  };
});
var selectPanel = ActionCreator('SELECT_PANEL', function (panelLocation) {
  return {
    panelLocation: panelLocation
  };
});
var closeEditorDrawer = ActionCreator('CLOSE_EDITOR_DRAWER');
var resetState = ActionCreator('RESET_STATE');
var editorUndo = ActionCreator('UNDO_EDITOR_CHANGE');
var editorRedo = ActionCreator('REDO_EDITOR_CHANGE');
var duplicateElement = ActionCreator('DUPLICATE_ELEMENT');
var layerUp = ActionCreator('LAYER_UP', function (elementLocation) {
  return {
    elementLocation: elementLocation
  };
});
var layerDown = ActionCreator('LAYER_DOWN', function (elementLocation) {
  return {
    elementLocation: elementLocation
  };
});
var setEditing = ActionCreator('SET_EDITING', function (editing) {
  return {
    editing: editing
  };
});
var setFullBleedBackgroundImage = ActionCreator('SET_FULLBLEED_BACKGROUND_IMAGE', function (image) {
  return {
    image: image
  };
});
var deleteFullBleedBackgroundImage = ActionCreator('DELETE_FULL_BLEED_BACKGROUND_IMAGE');
var updateFullBleedBackgroundImagePosition = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_IMAGE_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateFullBleedBackgroundImageScale = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_IMAGE_SCALE', function (scale) {
  return {
    scale: scale
  };
});
var updateFullBleedBackgroundElementPosition = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_POSITION', function (x, y) {
  return {
    x: x,
    y: y
  };
});
var updateFullBleedBackgroundElementSize = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_SIZE', function (width, height) {
  return {
    width: width,
    height: height
  };
});
var updateFullBleedBackgroundElementRotation = ActionCreator('UPDATE_FULL_BLEED_BACKGROUND_ELEMENT_ROTATION', function (rotation) {
  return {
    rotation: rotation
  };
});

var selectedFullBleed = function (_a) {
  var card = _a.card,
      fullBleedLocation = _a.fullBleedLocation;
  return card && isNumber(fullBleedLocation) ? card.fullBleeds[fullBleedLocation] : undefined;
};
var selectedPanel = function (_a) {
  var card = _a.card,
      fullBleedLocation = _a.fullBleedLocation,
      panelLocation = _a.panelLocation;
  return card && isNumber(panelLocation) ? card.fullBleeds[fullBleedLocation].panels[panelLocation !== null && panelLocation !== void 0 ? panelLocation : 0] : undefined;
};
var selectedElement = function (editor) {
  var _a;

  var card = editor.card,
      fullBleedLocation = editor.fullBleedLocation,
      panelLocation = editor.panelLocation,
      activeElement = editor.activeElement;

  if (!card || !isNumber(activeElement.location)) {
    return undefined;
  }

  if (isNumber(panelLocation)) {
    var panel = selectedPanel(editor);
    return panel ? panel.elements[(_a = activeElement.location) !== null && _a !== void 0 ? _a : 0] : undefined;
  } else {
    return card.fullBleeds[fullBleedLocation].backgroundElement;
  }
}; // TODO: Type this

var computedElements = function (elements, panel, fullBleed, selection) {
  return elements.map(function (element, location) {
    var points = {
      x: element.x * panel.width,
      y: element.y * panel.height,
      width: element.width * panel.width,
      height: element.height * panel.height
    };
    var isSelected = fullBleed.location === selection.fullBleed && panel.location === selection.panel && location === selection.element;

    var textState = __assign({
      fragments: element.text ? element.text.fragments : []
    }, selection.textSelection || {
      start: 0,
      end: 0,
      overrideProperties: {}
    });

    var computedElement = __assign(__assign({}, element), {
      text: element.text ? computedElementText(textState, isSelected) : null,
      location: location,
      isSelected: isSelected,
      points: points
    });

    return computedElement;
  });
};

var computedPanels = function (panels, fullBleed, selection) {
  return panels.map(function (panel, location) {
    var points = {
      x: panel.x * fullBleed.width,
      y: panel.y * fullBleed.height,
      width: panel.width * fullBleed.width,
      height: panel.height * fullBleed.height
    };
    return __assign(__assign({}, panel), {
      location: location,
      isSelected: fullBleed.location === selection.fullBleed && location === selection.panel,
      points: points,
      elements: computedElements(panel.elements, {
        location: location,
        width: points.width,
        height: points.height
      }, fullBleed, selection)
    });
  });
}; // TODO - was ComputedFullBleed[] (causing errors with flatMap)


var computedFullBleeds = function (editor) {
  return editor.card ? editor.card.fullBleeds.map(function (fullBleed, location) {
    return __assign(__assign({}, fullBleed), {
      location: location,
      backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
        location: 0,
        isSelected: !isNumber(editor.panelLocation),
        points: {
          x: fullBleed.backgroundElement.x * fullBleed.width,
          y: fullBleed.backgroundElement.y * fullBleed.height,
          width: fullBleed.backgroundElement.width * fullBleed.width,
          height: fullBleed.backgroundElement.height * fullBleed.height
        }
      }) : null,
      panels: computedPanels(fullBleed.panels, {
        location: location,
        width: fullBleed.width,
        height: fullBleed.height
      }, {
        fullBleed: editor.fullBleedLocation,
        panel: editor.panelLocation,
        element: editor.activeElement.location,
        textSelection: editor.textSelection
      })
    });
  }) : [];
};
var computedSingleFullBleeds = function (editor) {
  return computedFullBleeds(editor).flatMap(function (fullbleed) {
    return fullbleed.panels.map(function (panel) {
      return __assign(__assign({}, fullbleed), {
        panels: [panel]
      });
    });
  });
};
var getPanelLocations = function (editor) {
  return computedFullBleeds(editor).flatMap(function (fullbleed, fullbleedLocation) {
    return fullbleed.panels.map(function (_, panelLocation) {
      return {
        fullbleed: fullbleedLocation,
        panel: panelLocation
      };
    });
  });
};
var isHorizontalFullBleed = function (view, index, numFullBleeds, numPanels, isHorizontal) {
  // All back panels (for now) are portrait
  if (index === numFullBleeds - 1) {
    return false;
  }

  if (view === 'panel') {
    return isHorizontal;
  } else {
    if (index !== 1) {
      return isHorizontal;
    }

    if (numPanels > 1) {
      return !isHorizontal;
    }
  }

  return isHorizontal;
};

var black = {
  r: 0,
  g: 0,
  b: 0
};
var rgbString = function (color) {
  return "rgb(" + color.r + ", " + color.g + ", " + color.b + ")";
};

var defaultFragment = {
  fontFamily: 'HelveticaV2',
  fontSize: 16,
  color: black,
  textAlign: 'CENTER'
};
var signatureCharacter = 'æ'; // type IncompleteFragment = {

var textState = function (editor) {
  var element = selectedElement(editor);
  var textSelection = editor.textSelection;
  return element && element.text && textSelection ? __assign(__assign({}, textSelection), {
    fragments: element.text.fragments
  }) : {
    fragments: [defaultFragment],
    start: 1,
    end: 1,
    overrideProperties: {}
  };
};
var paragraphStart = function (textState) {
  return textState.fragments.slice(0, textState.start).reduce(function (acc, fragment, index) {
    return fragment.textAlign ? index : acc;
  }, 0);
};
var insertionTextAlign = function (textState) {
  return textState.fragments[paragraphStart(textState)].textAlign;
};
var insertionProperties = function (textState) {
  var insertionProperties = __assign(__assign({}, textState.fragments[textState.start === textState.end ? textState.start - 1 : textState.start]), textState.overrideProperties);

  var textAlign = insertionProperties.textAlign,
      signatureFontFamily = insertionProperties.signatureFontFamily,
      text = insertionProperties.text,
      remainingProperties = __rest(insertionProperties, ["textAlign", "signatureFontFamily", "text"]);

  return remainingProperties;
};
var paragraphs = function (fragments) {
  return fragments.reduce(function (paragraphs, fragment, index) {
    var lastIndex = paragraphs.length - 1;
    var lastParagraph = paragraphs[lastIndex];
    return fragment.textAlign ? __spread(paragraphs, [{
      index: index,
      fontFamily: fragment.fontFamily,
      fontSize: fragment.fontSize,
      color: fragment.color,
      textAlign: fragment.textAlign,
      fragments: []
    }]) : __spread(paragraphs.slice(0, lastIndex), [__assign(__assign({}, lastParagraph), {
      fragments: __spread(lastParagraph.fragments, [__assign(__assign({}, fragment), {
        index: index
      })])
    })]);
  }, []);
};

var selectedFragments = function (textState) {
  // todo look into alignment and why first element is being pulled, is it a line break?
  return textState.fragments.slice(1, textState.end);
};

var selectedText = function (textState) {
  return textState.fragments.map(function (fragment) {
    return fragment.text ? fragment.text : fragment.signatureFontFamily ? '' : '\n';
  }).join('');
};

var selectedProperty = function (textState, key) {
  return textState.start === textState.end ? insertionProperties(textState)[key] : textState.fragments.slice(textState.start, textState.end).map(function (fragment) {
    return fragment[key];
  }).reduce(function (acc, value) {
    return acc === value ? acc : undefined;
  });
}; // TODO change any types
var selectedFontSize = function (textState) {
  return selectedProperty(textState, 'fontSize');
};
var selectedColor = function (textState) {
  return selectedProperty(textState, 'color');
};

var selectionPaths = function (textState) {
  return textState.fragments.reduce(function (_a, fragment) {
    var paragraph = _a.paragraph,
        offset = _a.offset,
        selectionPaths = _a.selectionPaths;
    var newParagraph = fragment.textAlign ? paragraph + 1 : paragraph;
    var newOffset = fragment.textAlign ? 0 : offset + 1;
    return {
      paragraph: newParagraph,
      offset: newOffset,
      selectionPaths: __spread(selectionPaths, [{
        paragraph: newParagraph,
        offset: newOffset
      }])
    };
  }, {
    paragraph: -1,
    offset: -1,
    selectionPaths: Array()
  }).selectionPaths;
};

var paragraphSelection = function (textState) {
  var paths = selectionPaths(textState);
  return {
    start: __assign(__assign({}, paths[textState.start - 1]), {
      index: textState.start
    }),
    end: __assign(__assign({}, paths[textState.end - 1]), {
      index: textState.end
    }),
    fragments: selectedFragments(textState),
    text: selectedText(textState)
  };
};
var computedElementText = function (textState, isSelected) {
  return {
    paragraphs: paragraphs(textState.fragments),
    selectionUpperBound: textState.fragments.length,
    selection: isSelected ? paragraphSelection(textState) : undefined
  };
};

var updateCard$1 = function (state, transform) {
  return __assign(__assign({}, state), {
    card: state.card ? transform(state.card) : null
  });
};
var updateFullBleed = function (state, transform) {
  return updateCard$1(state, function (card) {
    return __assign(__assign({}, card), {
      fullBleeds: card.fullBleeds.map(function (fullBleed, location) {
        return location === state.fullBleedLocation ? transform(fullBleed) : fullBleed;
      })
    });
  });
};
var updatePanel = function (state, transform) {
  return updateFullBleed(state, function (fullBleed) {
    return __assign(__assign({}, fullBleed), {
      panels: fullBleed.panels.map(function (panel, location) {
        return location === state.panelLocation ? transform(panel) : panel;
      })
    });
  });
};
var updateElement = function (state, transform) {
  return updatePanel(state, function (panel) {
    return __assign(__assign({}, panel), {
      elements: panel.elements.map(function (element, location) {
        return location === state.activeElement.location ? transform(element, panel) : element;
      })
    });
  });
};
var updateElementImage = function (state, transform) {
  return updateElement(state, function (element) {
    return __assign(__assign({}, element), {
      movingProhibited: element.movingProhibited,
      image: element.image ? transform(element.image) : null
    });
  });
};
var textElement = {
  image: null,
  text: {
    fragments: [defaultFragment]
  }
};
var imageElement = {
  text: null,
  image: {
    image: null,
    filter: null,
    position: {
      x: 0.5,
      y: 0.5
    },
    scale: 1
  }
};
var fullBleedBackgroundImage = {
  image: {
    id: null,
    height: null,
    width: null,
    url: null
  },
  filter: null,
  position: {
    x: 0.5,
    y: 0.5
  },
  scale: 1
};
var addElement$1 = function (panel, type, isFullPanel) {
  var size = isFullPanel && type === 'image' ? {
    x: 0,
    y: 0,
    width: 1,
    height: 1
  } : isFullPanel ? {
    x: 0.05,
    y: 0.05,
    width: 0.9,
    height: 0.9
  } : {
    x: 0.1,
    y: 0.1,
    width: 0.5,
    height: 0.3
  };
  return __assign(__assign(__assign({}, size), {
    z: panel.elements.length + 1,
    rotation: 0,
    draggable: isFullPanel ? false : true,
    locked: false
  }), type === 'image' ? imageElement : textElement);
};
var isElementType = function (valueToCheck) {
  var element = valueToCheck;

  if ((element.height || element.width || element.x || element.y || element.z) !== undefined) {
    return true;
  }

  return false;
};
var getCopyLocation = function (activeElement) {
  var startingPoints = {
    x: activeElement.x,
    y: activeElement.y
  };
  var endingPoints = {
    x: activeElement.x + activeElement.width,
    y: activeElement.y + activeElement.height
  };
  return {
    x: startingPoints.x + getCopyDirection(endingPoints.x),
    y: startingPoints.y + getCopyDirection(endingPoints.y)
  };
};

var getCopyDirection = function (endPoint) {
  if (endPoint <= 0.99) {
    return 0.01;
  }

  return -0.01;
};

var insertText = ActionCreator('INSERT_TEXT', function (text) {
  return {
    text: text
  };
});
var selectFontFamily = ActionCreator('SELECT_FONT_FAMILY', function (fontFamily) {
  return {
    fontFamily: fontFamily
  };
});
var insertNewLine = ActionCreator('INSERT_NEW_LINE');
var selectColor = ActionCreator('SELECT_COLOR', function (color) {
  return {
    color: color
  };
});
var insertCharacter = ActionCreator('INSERT_CHARACTER', function (character) {
  return {
    character: character
  };
});
var insertSignature = ActionCreator('INSERT_SIGNATURE', function (signature) {
  return {
    signature: signature
  };
});
var insertFragments = ActionCreator('INSERT_FRAGMENTS', function (fragments) {
  return {
    fragments: fragments
  };
});
var selectTextAlign = ActionCreator('SELECT_TEXT_ALIGN', function (textAlign) {
  return {
    textAlign: textAlign
  };
});
var deleteForwardFragments = ActionCreator('DELETE_FORWARD_FRAGMENTS');
var deleteFragments = ActionCreator('DELETE_FRAGMENTS');
var selectFontSize = ActionCreator('SELECT_FONT_SIZE', function (fontSize) {
  return {
    fontSize: fontSize
  };
});
var insertPlaceholder = ActionCreator('INSERT_PLACEHOLDER', function (placeholder) {
  return {
    placeholder: placeholder
  };
});
var updateTextCasing = ActionCreator('UPDATE_TEXT_CASING', function (casing) {
  return {
    casing: casing
  };
});

var _insertFragments = function (state, fragments) {
  var start = state.start + fragments.length;
  return {
    fragments: __spread(state.fragments.slice(0, state.start), fragments, state.fragments.slice(state.end)),
    start: start,
    end: start,
    overrideProperties: {}
  };
};

var _insertCharacter = function (state, character) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    text: character
  })]);
};

var _insertPlaceholder = function (state, placeholder) {
  return _insertCharacter(state, placeholder);
};

var _insertText = function (state, text) {
  return _insertFragments(state, __spread(text).map(function (character) {
    return __assign(__assign({}, insertionProperties(state)), {
      text: character
    });
  }));
};

var _insertSignature = function (state, signatureFontFamily) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    signatureFontFamily: signatureFontFamily
  })]);
};

var _insertNewLine = function (state) {
  return _insertFragments(state, [__assign(__assign({}, insertionProperties(state)), {
    textAlign: insertionTextAlign(state)
  })]);
};

var _deleteFragments = function (state) {
  return _insertFragments(state.start === state.end && state.start > 1 ? __assign(__assign({}, state), {
    start: state.start - 1,
    overrideProperties: {}
  }) : state, []);
};

var _deleteForwardFragments = function (state) {
  if (state.start === state.end) {
    return {
      fragments: __spread(state.fragments.slice(0, state.start), state.fragments.slice(state.start + 1)),
      start: state.start,
      end: state.start,
      overrideProperties: {}
    };
  }

  return _insertFragments(state, []);
};

var _updateProperties = function (state, properties) {
  var hasNoFragements = state.fragments[state.start - 1].textAlign;
  var isFullTextHighlighted = state.start === 1 && state.end >= 2;

  if (hasNoFragements && !isFullTextHighlighted) {
    return __assign(__assign({}, state), {
      fragments: __spread(state.fragments.slice(0, state.start - 1), [__assign(__assign({}, state.fragments[state.start - 1]), properties)], state.fragments.slice(state.end))
    });
  } else {
    if (state.start !== state.end) {
      return __assign(__assign({}, state), {
        fragments: state.fragments.map(function (fragment, index) {
          return state.start <= index && index < state.end || index === state.start - 1 && fragment.textAlign ? __assign(__assign({}, fragment), properties) : fragment;
        })
      });
    } else {
      return __assign(__assign({}, state), {
        fragments: state.fragments.map(function (fragment) {
          return __assign(__assign({}, fragment), properties);
        })
      });
    }
  }
};

var _updateTextAlign = function (state, textAlign) {
  return __assign(__assign({}, state), {
    fragments: __spread(state.fragments.slice(0, paragraphStart(state)), state.fragments.slice(paragraphStart(state), state.end).map(function (fragment) {
      return fragment.textAlign ? __assign(__assign({}, fragment), {
        textAlign: textAlign
      }) : fragment;
    }), state.fragments.slice(state.end))
  });
};

var _updateTextCasing = function (state, casing) {
  return __assign(__assign({}, state), {
    fragments: __spread(state.fragments.slice(0, paragraphStart(state)), state.fragments.slice(paragraphStart(state), state.end).map(function (fragment, index) {
      switch (casing) {
        case 'uppercase':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: fragment.text.toUpperCase()
          }) : fragment;

        case 'lowercase':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: fragment.text.toLowerCase()
          }) : fragment;

        case 'capitalize':
          return fragment.text ? __assign(__assign({}, fragment), {
            text: index === 1 ? fragment.text.toUpperCase() : state.fragments[index - 1].text === ' ' ? fragment.text.toUpperCase() : fragment.text.toLowerCase()
          }) : fragment;

        default:
          return fragment;
      }
    }))
  });
};

var textReducer = (function (state, action) {
  switch (action.type) {
    case insertCharacter.type:
      return _insertCharacter(state, action.character);

    case insertText.type:
      return _insertText(state, action.text);

    case insertFragments.type:
      return _insertFragments(state, action.fragments);

    case insertSignature.type:
      return _insertSignature(state, action.signature);

    case insertPlaceholder.type:
      return _insertPlaceholder(state, action.placeholder);

    case insertNewLine.type:
      return _insertNewLine(state);

    case deleteFragments.type:
      return _deleteFragments(state);

    case deleteForwardFragments.type:
      return _deleteForwardFragments(state);

    case selectFontFamily.type:
      return _updateProperties(state, {
        fontFamily: action.fontFamily
      });

    case selectFontSize.type:
      return _updateProperties(state, {
        fontSize: action.fontSize
      });

    case selectColor.type:
      return _updateProperties(state, {
        color: action.color
      });

    case selectTextAlign.type:
      return _updateTextAlign(state, action.textAlign);

    case updateTextCasing.type:
      return _updateTextCasing(state, action.casing);

    default:
      return state;
  }
});

var Historian =
/** @class */
function () {
  function Historian(config) {
    var _this = this;

    this.addChange = function (changedObj) {
      if (_this.mutableCurrentState) {
        _this.mutableHistory.push(__assign({}, _this.mutableCurrentState));
      }

      _this.mutableCurrentState = __assign({}, changedObj);
      _this.mutableFuture = [];

      if (_this.mutableHistory.length > _this.numEntries) {
        _this.mutableHistory = _this.mutableHistory.slice(1, _this.mutableHistory.length);
      }
    };

    this.replaceCurrentState = function (changedObj) {
      _this.mutableCurrentState = __assign({}, changedObj);
      _this.mutableFuture = [];
    };

    this.undo = function () {
      if (_this.mutableHistory.length === 0) {
        return undefined;
      }

      var obj = _this.mutableHistory.pop();

      if (_this.mutableCurrentState) {
        _this.mutableFuture.push(__assign({}, _this.mutableCurrentState));
      }

      if (obj) {
        _this.mutableCurrentState = __assign({}, obj);
        return __assign({}, obj);
      }

      return undefined;
    };

    this.redo = function () {
      if (_this.mutableFuture.length === 0) {
        return undefined;
      }

      var obj = _this.mutableFuture.pop();

      if (_this.mutableCurrentState) {
        _this.mutableHistory.push(__assign({}, _this.mutableCurrentState));
      }

      if (obj) {
        _this.mutableCurrentState = __assign({}, obj);
        return __assign({}, obj);
      }

      return undefined;
    };

    this.reset = function () {
      _this.mutableCurrentState = undefined;
      _this.mutableHistory = [];
      _this.mutableFuture = [];
    };

    this.mutableHistory = [];
    this.mutableFuture = [];
    this.numEntries = config.numEntries;
    this.mutableCurrentState = config.startState;
  }

  return Historian;
}();

var CardHistorian = new Historian({
  numEntries: 100
});
var mutableActions = {
  prev: 'Bob',
  current: 'Blah',
  hasAddedBeforeReplacing: false
};
var actionsToIgnoreIfSame = ['SELECT_IMAGE_POSITION'];
var actionsIgnoreAltogether = ['SELECT_ELEMENT', 'SELECT_PANEL', 'SET_TOOLBAR_CONTEXT', 'ENABLE_SELECTING_ELEMENTS', 'DISABLE_SELECTING_ELEMENTS', 'REDO_EDITOR_CHANGE', 'UNDO_EDITOR_CHANGE', 'OPEN_IMAGE_DRAWER', 'OPEN_LAYOUT_DRAWER'];

var shouldUseReplace = function (isSame, type) {
  return actionsToIgnoreIfSame.some(function (action) {
    return action === type;
  }) && isSame;
};

var ignoreAltogether = function (type) {
  return actionsIgnoreAltogether.some(function (action) {
    return action === type;
  });
};

var keepCardHistory = function (state, action) {
  var card = state.card;
  mutableActions.current = action.type;

  if (action.type === 'LOADED_CARD') {
    CardHistorian.addChange(action.card);
    return;
  }

  if (action.type === 'RESET_STATE') {
    CardHistorian.reset();
    return;
  }

  if (card && shouldUseReplace(mutableActions.current === mutableActions.prev, action.type) && !ignoreAltogether(action.type)) {
    if (!mutableActions.hasAddedBeforeReplacing) {
      CardHistorian.addChange(card);
      mutableActions.hasAddedBeforeReplacing = true;
    }

    CardHistorian.replaceCurrentState(card);
  } else if (card && !ignoreAltogether(action.type)) {
    CardHistorian.addChange(card);
    mutableActions.hasAddedBeforeReplacing = false;
  }

  mutableActions.prev = mutableActions.current;
  return;
};

var initialState = {
  fullBleedLocation: 0,
  panelLocation: 0,
  loadError: null,
  layoutToLoad: null,
  activeToolbarAction: null,
  card: null,
  canSelectElements: true,
  activeElement: {
    location: null,
    type: null
  },
  editing: 'panel'
};
var editor = (function (state, action) {
  if (state === void 0) {
    state = initialState;
  }

  var newState = editorReducer(state, action);
  keepCardHistory(newState, action);
  return newState;
});

var editorReducer = function (state, action) {
  var _a, _b, _c;

  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case addElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'element',
        activeElement: {
          location: state.card && typeof state.panelLocation === 'number' ? state.card.fullBleeds[state.fullBleedLocation].panels[state.panelLocation].elements.length : 0,
          type: action.elementType
        }
      }), function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.concat(addElement$1(panel, action.elementType, !!action.isFullPanel))
        });
      });

    case disableSelectingElements.type:
      return __assign(__assign({}, state), {
        canSelectElements: false
      });

    case enableSelectingElements.type:
      return __assign(__assign({}, state), {
        canSelectElements: true
      });

    case setToolbarAction.type:
      return __assign(__assign({}, state), {
        activeToolbarAction: action.toolbarAction
      });

    case loadedCard.type:
      return __assign(__assign({}, state), {
        card: action.card
      });

    case setPanelBackground.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          backgroundColor: action.color
        });
      });

    case removeElement.type:
      return updatePanel(__assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      }), function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.filter(function (_, location) {
            return location !== state.activeElement.location;
          })
        });
      });

    case selectFullBleed.type:
      return __assign(__assign({}, state), {
        fullBleedLocation: action.fullBleedLocation,
        panelLocation: 0,
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined
      });

    case selectPanel.type:
      return __assign(__assign({}, state), {
        panelLocation: action.panelLocation,
        activeElement: {
          location: null,
          type: null
        },
        activeToolbarAction: null,
        textSelection: undefined,
        editing: 'panel'
      });

    case selectSinglePanel.type:
      return __assign(__assign({}, state), {
        fullBleedLocation: action.fullBleedLocation,
        panelLocation: action.panelLocation,
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined
      });

    case selectElement.type:
      return __assign(__assign({}, state), {
        panelLocation: action.panelLocation,
        activeElement: action.activeElement,
        textSelection: action.textStart ? {
          start: action.textStart,
          end: action.textEnd ? action.textEnd : action.textStart,
          overrideProperties: state.textSelection ? state.textSelection.overrideProperties : {}
        } : undefined,
        editing: 'element'
      });

    case deselectElement.type:
      return __assign(__assign({}, state), {
        editing: 'panel',
        activeElement: {
          location: null,
          type: null
        }
      });

    case selectImage.type:
      var image_1 = action.photo;
      return updateElementImage(__assign({}, state), function () {
        return {
          image: {
            id: image_1.id,
            url: decodeURI(image_1.url),
            width: image_1.width,
            height: image_1.height
          },
          position: {
            x: 0.5,
            y: 0.5
          },
          scale: 1,
          filter: null
        };
      });

    case toggleElementDraggable.type:
      return __assign({}, updateElement(state, function (element) {
        return __assign(__assign({}, element), {
          draggable: !element.draggable
        });
      }));

    case selectImagePosition.type:
      return updateElementImage(state, function (image) {
        var _a, _b;

        return __assign(__assign({}, image), {
          position: {
            x: (_a = action.x) !== null && _a !== void 0 ? _a : image.position.x,
            y: (_b = action.y) !== null && _b !== void 0 ? _b : image.position.y
          }
        });
      });

    case selectImageScale.type:
      return updateElementImage(state, function (image) {
        // when the scale changes to 1 from anything less than 1
        // it looks like it is fine on the editor, but it
        // is actually positioned wrong, this fix below forces it to center
        // if the user likes this position, it will be fine when
        // flattened, if they want to manually move it, it will still
        // be updated as usual
        return __assign(__assign({}, image), {
          scale: action.scale
        });
      });

    case selectFilter.type:
      return updateElementImage(state, function (image) {
        return __assign(__assign({}, image), {
          filterUrl: action.url,
          filter: {
            name: action.filterName
          }
        });
      });

    case removeImage.type:
      return updateElementImage(state, function () {
        return {
          image: null,
          position: {
            x: 0.5,
            y: 0.5
          },
          scale: 1,
          filter: null
        };
      });

    case selectLayout.type:
      return __assign({}, updatePanel(__assign(__assign({}, state), {
        layoutToLoad: null
      }), function (panel) {
        var elementImages = panel.elements.filter(function (element) {
          return element.image;
        }).map(function (element) {
          return element.image;
        });
        var elementTexts = panel.elements.filter(function (element) {
          return element.text;
        }).map(function (element) {
          return element.text;
        });
        return __assign(__assign({}, panel), {
          elements: action.layout.panel.elements.map(function (element) {
            if (element.image) {
              return element.image.image ? element : __assign(__assign({}, element), {
                image: elementImages.length > 0 ? elementImages.shift() || null : element.image
              });
            } else {
              return element.text && element.text.fragments.length > 1 ? element : __assign(__assign({}, element), {
                text: elementTexts.length > 0 ? elementTexts.shift() || null : element.text
              });
            }
          })
        });
      }));
    // case actions.selectBackPanel.type:
    //   return updatePanel(state, (panel: Panel) => {
    //     return {
    //       ...panel,
    //       elements: action.layout.panel.elements.map(EditorElement),
    //     }
    //   })

    case selectLayoutToLoad.type:
      return __assign(__assign({}, state), {
        layoutToLoad: action.layoutId
      });

    case setCard.type:
      return __assign(__assign({}, state), {
        card: action.card
      });

    case updateElementPosition.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.map(function (element, location) {
            var _a, _b;

            return location === action.elementLocation ? __assign(__assign({}, element), {
              x: (_a = action.x) !== null && _a !== void 0 ? _a : element.x,
              y: (_b = action.y) !== null && _b !== void 0 ? _b : element.y
            }) : element;
          })
        });
      });

    case updateElementSize.type:
      return updatePanel(state, function (panel) {
        return __assign(__assign({}, panel), {
          elements: panel.elements.map(function (element, location) {
            var _a, _b;

            return location === action.elementLocation ? __assign(__assign({}, element), {
              width: (_a = action.width) !== null && _a !== void 0 ? _a : element.width,
              height: (_b = action.height) !== null && _b !== void 0 ? _b : element.height
            }) : element;
          })
        });
      });

    case updateElementRotation.type:
      {
        return updatePanel(state, function (panel) {
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element, location) {
              return location === action.elementLocation ? __assign(__assign({}, element), {
                rotation: action.rotation
              }) : element;
            })
          });
        });
      }

    case closeEditorDrawer.type:
      return __assign(__assign({}, state), {
        activeElement: {
          location: null,
          type: null
        },
        textSelection: undefined
      });

    case resetState.type:
      return __assign({}, initialState);

    case editorUndo.type:
      {
        var newCardState = CardHistorian.undo();

        if (newCardState) {
          return __assign(__assign({}, state), {
            card: newCardState
          });
        } else {
          return state;
        }
      }

    case editorRedo.type:
      {
        var newCardState = CardHistorian.redo();

        if (newCardState) {
          return __assign(__assign({}, state), {
            card: newCardState
          });
        } else {
          return state;
        }
      }

    case duplicateElement.type:
      {
        if (typeof state.fullBleedLocation === 'number' && typeof state.panelLocation === 'number' && typeof state.activeElement.location === 'number') {
          var activePanel = (_a = state.card) === null || _a === void 0 ? void 0 : _a.fullBleeds[state.fullBleedLocation].panels[state.panelLocation];
          var activeElement = activePanel === null || activePanel === void 0 ? void 0 : activePanel.elements[state.activeElement.location];

          if (isElementType(activeElement)) {
            var copy_1 = __assign(__assign(__assign({}, activeElement), getCopyLocation(activeElement)), {
              z: activeElement.z + 1
            });

            return updatePanel(__assign(__assign({}, state), {
              activeElement: {
                location: (_c = (_b = activePanel === null || activePanel === void 0 ? void 0 : activePanel.elements) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : null,
                type: activeElement.text ? 'text' : activeElement.image ? 'image' : null
              }
            }), function (panel) {
              return __assign(__assign({}, panel), {
                elements: panel.elements.concat(copy_1)
              });
            });
          }
        }

        return state;
      }

    case layerUp.type:
      {
        return updatePanel(state, function (panel) {
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element, location) {
              return location === action.elementLocation ? __assign(__assign({}, element), {
                z: element.z >= panel.elements.length + 1 ? element.z : element.z + 1
              }) : element;
            })
          });
        });
      }

    case layerDown.type:
      {
        return updatePanel(state, function (panel) {
          return __assign(__assign({}, panel), {
            elements: panel.elements.map(function (element, location) {
              return location === action.elementLocation ? __assign(__assign({}, element), {
                z: element.z === 0 ? element.z : element.z - 1
              }) : element;
            })
          });
        });
      }

    case setEditing.type:
      {
        var isEditingElement = action.editing === 'element';
        return __assign(__assign({}, state), {
          editing: action.editing,
          activeElement: {
            location: isEditingElement ? state.activeElement.location : null,
            type: isEditingElement ? state.activeElement.type : null
          }
        });
      }

    case setFullBleedBackgroundImage.type:
      {
        var image_2 = __assign(__assign({}, fullBleedBackgroundImage), {
          image: {
            url: action.image.url,
            height: action.image.height,
            width: action.image.width,
            id: action.image.id
          }
        });

        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                image: action.image
              }) : image_2
            }) : null
          });
        });
      }

    case deleteFullBleedBackgroundImage.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              x: 0,
              y: 0,
              z: 0,
              width: 1,
              height: 1,
              rotation: 0,
              image: null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundImagePosition.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                position: {
                  x: (_a = action.x) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.image.position.x,
                  y: (_b = action.y) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.image.position.y
                }
              }) : null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundImageScale.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              image: fullBleed.backgroundElement.image ? __assign(__assign({}, fullBleed.backgroundElement.image), {
                scale: action.scale
              }) : null
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementPosition.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              x: (_a = action.x) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.x,
              y: (_b = action.y) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.y
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementSize.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          var _a, _b;

          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              width: (_a = action.width) !== null && _a !== void 0 ? _a : fullBleed.backgroundElement.width,
              height: (_b = action.height) !== null && _b !== void 0 ? _b : fullBleed.backgroundElement.height
            }) : null
          });
        });
      }

    case updateFullBleedBackgroundElementRotation.type:
      {
        return updateFullBleed(state, function (fullBleed) {
          return __assign(__assign({}, fullBleed), {
            backgroundElement: fullBleed.backgroundElement ? __assign(__assign({}, fullBleed.backgroundElement), {
              rotation: action.rotation
            }) : null
          });
        });
      }

    default:
      if (state.textSelection) {
        var _d = textReducer(textState(state), action),
            fragments_1 = _d.fragments,
            textSelection = __rest(_d, ["fragments"]);

        return __assign(__assign({}, updateElement(state, function (element) {
          return __assign(__assign({}, element), {
            text: element.text ? {
              fragments: fragments_1
            } : null
          });
        })), {
          textSelection: textSelection
        });
      } else {
        return state;
      }

  }
};

var uploadedImage = ActionCreator('UPLOADED_IMAGE', function (image) {
  return {
    image: image
  };
});
var showImages = ActionCreator('SHOW_IMAGES');

var initialState$1 = {
  loading: false,
  images: [],
  hasMore: true
};
var images = (function (state, action) {
  if (state === void 0) {
    state = initialState$1;
  }

  switch (action.type) {
    case showImages.type:
      return __assign(__assign({}, state), {
        loading: true
      });

    default:
      return state;
  }
});

var openElementInsertDrawer = ActionCreator('OPEN_ELEMENT_INSERT_DRAWER', function (insertType) {
  return {
    insertType: insertType
  };
});
var closeElementInsertDrawer = ActionCreator('CLOSE_ELEMENT_INSERT_DRAWER');
var openElementSettingsDrawer = ActionCreator('OPEN_ELEMENT_SETTINGS_DRAWER', function (settingType) {
  return {
    settingType: settingType
  };
});
var closeElementSettingsDrawer = ActionCreator('CLOSE_ELEMENT_SETTINGS_DRAWER');
var setActiveImageSetting = ActionCreator('SET_ACTIVE_IMAGE_SETTING', function (activeSetting) {
  return {
    activeSetting: activeSetting
  };
});
var setActiveTextSetting = ActionCreator('SET_ACTIVE_TEXT_SETTING', function (activeSetting) {
  return {
    activeSetting: activeSetting
  };
});
var setShouldReplaceSelectedImage = ActionCreator('SET_SHOULD_REPLACE_SELECTED_IMAGE', function (shouldReplaceSelectedImage) {
  return {
    shouldReplaceSelectedImage: shouldReplaceSelectedImage
  };
});

var initialState$2 = {
  isElementInsertOpen: false,
  elementInsertDrawerType: null,
  isElementSettingsOpen: false,
  elementSettingsDrawerType: null,
  activeImageSetting: null,
  activeTextSetting: null,
  shouldReplaceSelectedImage: false
};
var editorChrome = (function (state, action) {
  if (state === void 0) {
    state = initialState$2;
  }

  switch (action.type) {
    case openElementInsertDrawer.type:
      return __assign(__assign({}, state), {
        isElementInsertOpen: true,
        elementInsertDrawerType: action.insertType
      });

    case closeElementInsertDrawer.type:
      return __assign(__assign({}, state), {
        isElementInsertOpen: false
      });

    case openElementSettingsDrawer.type:
      return __assign(__assign({}, state), {
        isElementSettingsOpen: true,
        elementSettingsDrawerType: action.settingType,
        activeImageSetting: null,
        activeTextSetting: null
      });

    case closeElementSettingsDrawer.type:
      return __assign(__assign({}, state), {
        isElementSettingsOpen: false,
        activeImageSetting: null,
        activeTextSetting: null
      });

    case setActiveImageSetting.type:
      return __assign(__assign({}, state), {
        activeImageSetting: action.activeSetting
      });

    case setActiveTextSetting.type:
      return __assign(__assign({}, state), {
        activeTextSetting: action.activeSetting
      });

    case setShouldReplaceSelectedImage.type:
      return __assign(__assign({}, state), {
        shouldReplaceSelectedImage: action.shouldReplaceSelectedImage
      });

    default:
      return state;
  }
});

var appReducer = combineReducers({
  images: images,
  editor: editor,
  editorChrome: editorChrome
}); // const composeEnhancers = (...args: StoreEnhancer[]) =>
//   process.env.NODE_ENV === 'production'
//     ? compose(...args)
//     : window && !!window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(...args)
//     : compose(...args)

var Store = function () {
  return createStore(appReducer, {}, composeWithDevTools());
};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  module.exports = _extends;
});

var EditorChromeContext = /*#__PURE__*/createContext({
  layouts: [],
  images: [],
  fonts: [],
  customFonts: [],
  signatures: [],
  placeholders: []
});
var EditorChromeProvider = EditorChromeContext.Provider;
var EditorChromeConsumer = EditorChromeContext.Consumer;

var connect = connect$1;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "w6h24w-ImageUploader",
  styles: "width:100%;label:ImageUploader;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var ImageUploader = function (props) {
  var onUploadImages = props.onUploadImages;
  return jsx("div", {
    css: _ref
  }, jsx("div", null, jsx("label", {
    htmlFor: "upload"
  }, jsx("div", {
    "aria-hidden": "true"
  }, "Upload Photo"), jsx("input", {
    id: "upload",
    type: "file",
    accept: ".jpg, .jpeg, .png, .gif",
    onChange: function (event) {
      event.preventDefault();

      if (event.target.files == null) {
        return;
      }

      var files = event.target.files;

      if (!!onUploadImages) {
        onUploadImages(files);
      } // const mutableReader = new FileReader()
      // mutableReader.onloadend = () => {
      //   const image = {
      //     id: '1',
      //     width: 1,
      //     height: 1,
      //     url: mutableReader.result as string,
      //   }
      //   selectImage(image)
      // }
      // mutableReader.readAsDataURL(files[0])

    },
    style: {
      display: 'none',
      lineHeight: 0
    }
  }))));
};

var ImageUploader$1 = connect(undefined, {
  selectImage: selectImage
})(ImageUploader);

var Images = function (props) {
  var _a, _b;

  var images = props.images,
      onUploadImages = props.onUploadImages,
      selectImage = props.selectImage,
      addElement = props.addElement,
      openElementSettingsDrawer = props.openElementSettingsDrawer,
      activeElement = props.activeElement,
      setFullBleedBackgroundImage = props.setFullBleedBackgroundImage,
      setActiveImageSetting = props.setActiveImageSetting,
      editing = props.editing,
      selectedFullBleed = props.selectedFullBleed,
      shouldReplaceSelectedImage = props.shouldReplaceSelectedImage,
      setShouldReplaceSelectedImage = props.setShouldReplaceSelectedImage;
  var hasFullBleedImage = ((_b = (_a = selectedFullBleed === null || selectedFullBleed === void 0 ? void 0 : selectedFullBleed.backgroundElement) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.image) ? true : false;

  var isImageElementIsSelected = function (location, elementType) {
    if (typeof location === 'number' && elementType === 'image') {
      return true;
    }

    return false;
  };

  var handleAddImage = function (image) {
    if (editing === 'fullbleed') {
      setFullBleedBackgroundImage(image);
    } else if (shouldReplaceSelectedImage && isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type)) {
      selectImage(image);
    } else {
      openElementSettingsDrawer('image');
      addElement('image');
      selectImage(image);
      setShouldReplaceSelectedImage(false);
      setActiveImageSetting(null);
    }
  };

  return jsx(Flex, {
    inset: 'x1',
    flexDirection: 'column',
    height: '100%'
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, editing === 'fullbleed' ? hasFullBleedImage ? 'Change background image' : 'Add background image' : isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) && shouldReplaceSelectedImage ? 'Change your image' : 'Add an image'), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, isImageElementIsSelected(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) && shouldReplaceSelectedImage ? 'Choose an image below to replace your current selection' : 'Choose an image below to add it to your selected panel'), jsx(Div, {
    width: '100%',
    outset: {
      vertical: 'x4'
    }
  }, jsx(Grid, {
    height: "100%",
    columnSize: 42,
    rowSize: 35,
    gap: 16
  }, images.map(function (image) {
    return jsx(GridItem, {
      gridColSpan: 2,
      gridRowSpan: image.width > image.height ? 2 : 4,
      borderRadius: 'medium',
      key: image.id
    }, jsx(Image$1, {
      image: {
        url: image.url
      },
      onClick: function () {
        return handleAddImage(image);
      },
      width: '100%',
      height: '100%',
      isActive: true,
      borderRadius: 'small'
    }));
  }))), jsx(ImageUploader$1, {
    onUploadImages: onUploadImages
  }));
};

var Images$1 = connect(function (_a) {
  var editor = _a.editor,
      editorChrome = _a.editorChrome;
  return {
    activeElement: editor.activeElement,
    editing: editor.editing,
    selectedFullBleed: selectedFullBleed(editor),
    shouldReplaceSelectedImage: editorChrome.shouldReplaceSelectedImage
  };
}, {
  selectImage: selectImage,
  addElement: addElement,
  selectElement: selectElement,
  setFullBleedBackgroundImage: setFullBleedBackgroundImage,
  openElementSettingsDrawer: openElementSettingsDrawer,
  setActiveImageSetting: setActiveImageSetting,
  setShouldReplaceSelectedImage: setShouldReplaceSelectedImage
})(Images);

var Layouts = function (_a) {
  var layouts = _a.layouts,
      selectLayout = _a.selectLayout,
      selectLayoutToLoad = _a.selectLayoutToLoad,
      orientation = _a.orientation;

  var handleLayout = function (layout) {
    var id = typeof layout.id === 'number' ? layout.id.toString() : layout.id;
    selectLayout(layout);
    selectLayoutToLoad(id);
  };

  return jsx(Flex, {
    inset: 'x1',
    flexDirection: 'column',
    height: '100%'
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Add a Design Layout"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Choose pre-designed layout below to add a nice design to your card"), jsx(Div, {
    width: '100%',
    outset: {
      vertical: 'x4'
    }
  }, jsx(Grid, {
    height: '100%',
    columnSize: 42,
    rowSize: 35,
    gap: 16
  }, layouts.map(function (layout) {
    var id = typeof layout.id === 'number' ? layout.id.toString() : layout.id;
    var isHorizontal = orientation === 'LANDSCAPE';
    return jsx(GridItem, {
      key: id,
      gridColSpan: 2,
      gridRowSpan: isHorizontal ? 2 : 4,
      borderRadius: 'medium'
    }, jsx(Image$1, {
      image: layout.thumbnail,
      onClick: function () {
        return handleLayout(layout);
      },
      width: '100%',
      height: '100%',
      isActive: true,
      borderRadius: 'small'
    }));
  }))));
};

var Layouts$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    orientation: editor.card && editor.card.orientation
  };
}, {
  selectLayout: selectLayout,
  selectLayoutToLoad: selectLayoutToLoad,
  closeEditorDrawer: closeEditorDrawer
})(Layouts);

var Settings = function (_a) {
  var sections = _a.sections;

  var _b = __read(useState(-1), 2),
      activeIndex = _b[0],
      setActiveIndex = _b[1];

  var onSettingSectionChange = function (section, index) {
    section.onClick();
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  return jsx(Accordion, {
    isExclusive: true,
    hasArrows: false,
    isHeadingBackgroundInverse: true,
    sections: sections.map(function (section, index) {
      return {
        heading: jsx(React.Fragment, null, jsx(Flex, null, jsx(HStack, {
          gap: "x1_5",
          justify: "flex-start"
        }, jsx(Flex, {
          alignItems: "center"
        }, jsx(Icon, {
          name: section.icon,
          size: "small",
          primaryColor: index === activeIndex ? 'primaryBrand' : 'default'
        })), jsx(Flex, {
          alignItems: "center"
        }, jsx(Text, {
          type: "footnote",
          weight: index === activeIndex ? 'semiBold' : 'regular'
        }, section.title))))),
        key: index,
        body: jsx(Div, {
          width: "100%"
        }, section.settings),
        onHeadingClick: function () {
          return onSettingSectionChange(section, index);
        }
      };
    })
  });
};

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

var ElementIncrementSetting = function (_a) {
  var title = _a.title,
      min = _a.min,
      max = _a.max,
      callback = _a.callback,
      initial = _a.initial,
      resetDependency = _a.resetDependency,
      activeElement = _a.activeElement,
      panelLocation = _a.panelLocation,
      _b = _a.sliderOrigin,
      sliderOrigin = _b === void 0 ? 'left' : _b;

  var _c = __read(useState(initial * 100), 2),
      value = _c[0],
      setValue = _c[1];

  var _d = __read(useState(false), 2),
      isDisabled = _d[0],
      setIsDisabled = _d[1];

  var previousValue = usePrevious(value);

  var handleNoRange = function () {
    setIsDisabled(true);
    setValue(min);
  };

  useEffect(function () {
    if (min === max) {
      handleNoRange();
      return;
    }

    setIsDisabled(false);

    if (previousValue === value) {
      return;
    }

    callback(value / 100);
  }, [value, min, max]); // eslint-disable-line

  useEffect(function () {
    setValue(Math.floor(Math.round(initial * 100)));
  }, [activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, panelLocation, resetDependency]); // eslint-disable-line

  return jsx(IncrementSetting, {
    sliderOrigin: sliderOrigin,
    isDisabled: isDisabled,
    title: title,
    min: min,
    max: max,
    value: value,
    setValue: setValue,
    layout: "inlineBlock"
  });
};

var ElementIncrementSetting$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    activeElement: editor.activeElement,
    panelLocation: editor.panelLocation
  };
})(ElementIncrementSetting);

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$1 = process.env.NODE_ENV === "production" ? {
  name: "md1npv",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-size:12px"
} : {
  name: "1iz8stv-FontTile",
  styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-size:12px;label:FontTile;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var FontTile = function (_a) {
  var font = _a.font,
      size = _a.size,
      color = _a.color,
      setFont = _a.setFont,
      active = _a.active;
  var primaryBrand = useColorSwatch().primaryBrand;
  return jsx(Flex, {
    flexDirection: 'column',
    outset: {
      bottom: 'x_5',
      left: 'x_5'
    },
    onClick: function () {
      return setFont(font.fontName);
    },
    cursor: "pointer"
  }, jsx(Flex, {
    justifyContent: 'center',
    alignItems: 'center',
    width: size + "px",
    height: size + "px",
    backgroundColor: color,
    borderRadius: 'default',
    outset: {
      bottom: 'x_5'
    },
    position: "relative",
    borderColor: active ? primaryBrand.base : 'transparent',
    borderStyle: "solid",
    borderWidth: "bold"
  }, jsx("p", {
    css: /*#__PURE__*/css({
      fontFamily: font.fontName,
      textAlign: 'center'
    }, process.env.NODE_ENV === "production" ? "" : ";label:FontTile;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }, font.displayName), active && jsx(Flex, {
    position: "absolute",
    bottom: "x_25",
    right: "x_25",
    borderRadius: "circle",
    borderColor: "foreground",
    borderStyle: "solid",
    borderWidth: "thin",
    backgroundColor: primaryBrand.base
  }, jsx(Flex, {
    inset: "x_25"
  }, jsx(Icon, {
    name: "check",
    primaryColor: "inverseBodyText",
    size: "xSmall"
  })))), jsx(Div, {
    css: _ref$1
  }, font.displayName));
};

var FontFamilyGrid = function (_a) {
  var fonts = _a.fonts,
      customFonts = _a.customFonts,
      tileSize = _a.tileSize,
      onFontChange = _a.onFontChange;

  var _b = useColorSwatch(),
      primaryBrand = _b.primaryBrand,
      secondaryBrand = _b.secondaryBrand,
      success = _b.success,
      warning = _b.warning,
      danger = _b.danger; // TODO - Add return types to prevent TS issues


  var swatches = [primaryBrand, secondaryBrand, success, warning, danger];

  var _c = __read(useState(''), 2),
      fontSearch = _c[0],
      setFontSearch = _c[1];

  var _d = __read(useState(-1), 2),
      activeFontIndex = _d[0],
      setActiveFontIndex = _d[1];

  var omit = function (obj, arr) {
    return Object.keys(obj).filter(function (key) {
      return !arr.includes(key);
    }).reduce(function (acc, key) {
      return acc[key] = obj[key], acc;
    }, {});
  };

  var filteredSwatches = swatches.map(function (swatch) {
    return omit(swatch, ['base', '_100', '_200', '_900', '_1000']);
  });
  var colors = filteredSwatches.map(function (swatch) {
    return Object.values(swatch);
  }).reduce(function (a, b) {
    return __spread(a, b);
  }, []);

  var handleFontChange = function (font, i) {
    onFontChange(font);
    setActiveFontIndex(i);
  };

  return jsx(React.Fragment, null, jsx(Input, {
    isFullWidth: true,
    type: "text",
    value: fontSearch,
    onChange: setFontSearch,
    icon: "search",
    placeholder: "Search Fonts"
  }), jsx(Spacer, {
    space: "x2"
  }), jsx(Tabs, {
    defaultActiveKey: "system",
    height: "400px"
  }, jsx(Tab, {
    title: "System",
    tabKey: "system"
  }, jsx(Grid, {
    columnSize: tileSize,
    rowSize: tileSize,
    gap: 4
  }, fonts.map(function (font, i) {
    var isMatch = font.displayName.toLowerCase().includes(fontSearch.toLowerCase());
    var random = Math.floor(Math.random() * Math.floor(colors.length));
    return isMatch && jsx(GridItem, {
      key: font.fontName
    }, jsx(FontTile, {
      font: font,
      size: tileSize,
      color: colors[random],
      setFont: function () {
        return handleFontChange(font.fontName, i);
      },
      active: i === activeFontIndex
    }));
  }))), jsx(Tab, {
    title: "Custom",
    tabKey: "custom"
  }, customFonts === null || customFonts === void 0 ? void 0 : customFonts.map(function (customFont, i) {
    var isMatch = customFont.displayName.toLowerCase().includes(fontSearch.toLowerCase());
    var random = Math.floor(Math.random() * Math.floor(colors.length));
    return isMatch && jsx(GridItem, {
      key: customFont.fontName
    }, jsx(FontTile, {
      font: customFont,
      size: tileSize,
      color: colors[random],
      setFont: function () {
        return handleFontChange(customFont.fontName, i);
      },
      active: i === activeFontIndex
    }));
  }), !customFonts && jsx("div", null, "Add custom fonts here"))));
};

var FontFamilySettings = function (_a) {
  var selectFontFamily = _a.selectFontFamily;

  var _b = useContext(EditorChromeContext),
      fonts = _b.fonts,
      customFonts = _b.customFonts;

  return jsx(FontFamilyGrid, {
    fonts: fonts,
    customFonts: customFonts,
    tileSize: 100,
    onFontChange: selectFontFamily
  });
};

var FontFamilySettings$1 = connect(null, {
  selectFontFamily: selectFontFamily
})(FontFamilySettings);

var alignmentOptions = [{
  icon: 'alignLeft',
  alignment: 'LEFT'
}, {
  icon: 'alignCenter',
  alignment: 'CENTER'
}, {
  icon: 'alignRight',
  alignment: 'RIGHT'
}];

var AlignmentSettings = function (_a) {
  var selectTextAlign = _a.selectTextAlign;

  var _b = __read(useState(-1), 2),
      selectedAlignmentIndex = _b[0],
      setSelectedAlignmentIndex = _b[1];

  var onAlignmentChange = function (alignment, index) {
    selectTextAlign(alignment);
    setSelectedAlignmentIndex(index);
  };

  return jsx(VStack, {
    gap: "x1"
  }, jsx(Text, {
    type: "footnote"
  }, "Alignment:"), jsx(HStack, {
    gap: "x5",
    justify: "flex-start"
  }, alignmentOptions.map(function (option, index) {
    return jsx(IconLink, {
      key: option.alignment + " " + index,
      icon: option.icon,
      onClick: function () {
        return onAlignmentChange(option.alignment, index);
      },
      activeColor: "primaryBrand",
      isActive: index === selectedAlignmentIndex
    });
  })));
};

var AlignmentSettings$1 = connect$1(null, {
  selectTextAlign: selectTextAlign
})(AlignmentSettings);

var ColorPicker = function (_a) {
  var defaultColor = _a.defaultColor,
      onColorChange = _a.onColorChange,
      itemLocation = _a.itemLocation,
      _b = _a.canRemoveColor,
      canRemoveColor = _b === void 0 ? false : _b;

  var _c = __read(useState(defaultColor), 2),
      color = _c[0],
      setColor = _c[1];

  var _d = __read(useState(false), 2),
      isChecked = _d[0],
      setIsChecked = _d[1];

  useEffect(function () {
    setColor(defaultColor);
    setIsChecked(false);
  }, [itemLocation]); //eslint-disable-line

  useEffect(function () {
    if (isChecked) {
      onColorChange(null);
    } else {
      onColorChange(color);
    }
  }, [isChecked, itemLocation]); //eslint-disable-line

  return jsx(VStack, {
    gap: "x2"
  }, jsx(QuantumColorPicker, {
    type: "rgb",
    defaultColor: color,
    callback: function (color) {
      return onColorChange(color);
    }
  }), canRemoveColor && jsx(Flex, {
    width: "100%"
  }, jsx(Checkbox, {
    label: "Remove Color",
    onChange: setIsChecked,
    isChecked: isChecked
  })));
};

var InsertSettings = function (_a) {
  var onInsertSignature = _a.onInsertSignature,
      onInsertPlaceholder = _a.onInsertPlaceholder;

  var _b = useContext(EditorChromeContext),
      placeholders = _b.placeholders,
      signatures = _b.signatures;

  return jsx(Flex, null, jsx(Tabs, {
    defaultActiveKey: "signatures",
    height: '400px'
  }, jsx(Tab, {
    tabKey: "signatures",
    title: "Signatures"
  }, signatures ? jsx(List, {
    orientation: "vertical",
    alignment: "left"
  }, signatures.map(function (signature) {
    return jsx(ListItem, {
      inset: "x1",
      orientation: "vertical",
      onClick: function () {
        return onInsertSignature(signature.fontName);
      }
    }, jsx("span", {
      key: signature.fontName,
      css: /*#__PURE__*/css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                        cursor: pointer;\n                        font-family: ", ";\n                        font-size: 40;\n                        padding: 16px 0;\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:InsertSettings;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n                        cursor: pointer;\n                        font-family: ", ";\n                        font-size: 40;\n                        padding: 16px 0;\n                      " + (process.env.NODE_ENV === "production" ? "" : ";label:InsertSettings;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), signature.fontName)
    }, "\xE6"));
  })) : jsx(Text, {
    type: "body"
  }, "You don't have any signatures")), jsx(Tab, {
    tabKey: "placeholder",
    title: "Placeholders"
  }, jsx(List, {
    alignment: "left",
    orientation: "vertical"
  }, placeholders === null || placeholders === void 0 ? void 0 : placeholders.map(function (placeholder) {
    return jsx(ListItem, {
      onClick: function () {
        return onInsertPlaceholder(placeholder);
      },
      inset: "x1",
      orientation: "vertical",
      key: placeholder,
      cursor: "pointer"
    }, jsx(Text, {
      color: "primaryHeading",
      type: "body"
    }, placeholder));
  })))));
};
var templateObject_1;

var casingOptions = [{
  icon: 'uppercaseText',
  casing: 'uppercase'
}, {
  icon: 'lowercaseText',
  casing: 'lowercase'
}, {
  icon: 'capitalizedText',
  casing: 'capitalize'
}];
var CasingSettings = function (_a) {
  var onTextCasingUpdate = _a.onTextCasingUpdate,
      originalText = _a.originalText;

  var _b = __read(useState(null), 2),
      activeCasing = _b[0],
      setActiveCasing = _b[1];

  var isUpperCase = function (words) {
    return words === words.toUpperCase();
  };

  var isLowerCase = function (words) {
    return words === words.toLowerCase();
  };

  var isCapitalized = function (words) {
    var capitalizedWords = words.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    return words === capitalizedWords;
  };

  useEffect(function () {
    if (isUpperCase(originalText)) {
      setActiveCasing('uppercase');
    } else if (isLowerCase(originalText)) {
      setActiveCasing('lowercase');
    } else if (isCapitalized(originalText)) {
      setActiveCasing('capitalize');
    } else {
      setActiveCasing(null);
    }
  }, [originalText]);
  return jsx(VStack, {
    gap: "x1"
  }, jsx(Text, {
    type: "footnote"
  }, "Casing:"), jsx(HStack, {
    gap: "x5",
    justify: "flex-start"
  }, casingOptions.map(function (option, index) {
    return jsx(IconLink, {
      key: option.casing + " " + index,
      icon: option.icon,
      onClick: function () {
        return onTextCasingUpdate(option.casing);
      },
      activeColor: "primaryBrand",
      isActive: activeCasing === option.casing
    });
  })));
};

var DEFAULT_FONT_SIZE = 16;

var TextSettings = function (props) {
  var selectedElement = props.selectedElement,
      setActiveTextSetting = props.setActiveTextSetting,
      updateElementRotation = props.updateElementRotation,
      setFontSize = props.setFontSize,
      fontSize = props.fontSize,
      selectColor = props.selectColor,
      color = props.color,
      activeElement = props.activeElement,
      insertPlaceholder = props.insertPlaceholder,
      insertSignature = props.insertSignature,
      updateTextCasing = props.updateTextCasing,
      text = props.text;
  return selectedElement ? jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Text Settings:"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Apply the following setting to your selected text"), jsx(Div, {
    outset: {
      vertical: 'auto'
    }
  }, jsx(Settings, {
    sections: [{
      title: 'Font Family',
      onClick: function () {
        return setActiveTextSetting('alignment');
      },
      icon: 'aText',
      settings: jsx(FontFamilySettings$1, null)
    }, {
      title: 'Settings',
      onClick: function () {
        return setActiveTextSetting('alignment');
      },
      icon: 'fontSize',
      settings: jsx(VStack, {
        gap: "x2"
      }, jsx(Div, null, jsx(ElementIncrementSetting$1, {
        initial: fontSize ? fontSize / 100 : DEFAULT_FONT_SIZE / 100,
        title: "Size:",
        min: 8,
        max: 80,
        callback: function (value) {
          return setFontSize(value * 100);
        },
        resetDependency: fontSize
      })), jsx(AlignmentSettings$1, null), jsx(CasingSettings, {
        originalText: text !== null && text !== void 0 ? text : '',
        onTextCasingUpdate: updateTextCasing
      }))
    }, {
      title: 'Color',
      onClick: function () {
        return setActiveTextSetting('casing');
      },
      icon: 'colorPalette',
      settings: jsx(ColorPicker, {
        defaultColor: color || {
          r: 51,
          b: 51,
          g: 51
        },
        onColorChange: function (color) {
          return selectColor(color);
        },
        itemLocation: (activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) || 0
      })
    }, {
      title: 'Rotate',
      onClick: function () {
        return setActiveTextSetting('rotate');
      },
      icon: 'rotateRight',
      settings: jsx(Div, {
        inset: {
          bottom: 'x3'
        }
      }, jsx(ElementIncrementSetting$1, {
        title: 'Rotation Degrees',
        initial: selectedElement.rotation / 100,
        callback: function (value) {
          return updateElementRotation(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location, value * 100);
        },
        min: -360,
        max: 360,
        sliderOrigin: "center"
      }))
    }, {
      title: 'Insert',
      onClick: function () {
        return setActiveTextSetting('casing');
      },
      icon: 'signature',
      settings: jsx(InsertSettings, {
        onInsertPlaceholder: insertPlaceholder,
        onInsertSignature: insertSignature
      })
    }]
  }))) : jsx("div", null, "There is no current text element selected");
};

var TextSettings$1 = connect(function (_a) {
  var editorChrome = _a.editorChrome,
      editor = _a.editor;
  return __assign({
    selectedElement: selectedElement(editor),
    activeElement: editor.activeElement,
    activeTextSetting: editorChrome.activeTextSetting,
    card: editor.card,
    panelLocation: editor.panelLocation,
    fullBleedLocation: editor.fullBleedLocation
  }, function (textState) {
    return {
      color: selectedColor(textState),
      fontSize: selectedFontSize(textState),
      text: selectedText(textState)
    };
  }(textState(editor)));
}, {
  updateElementRotation: updateElementRotation,
  selectColor: selectColor,
  setFontSize: selectFontSize,
  selectFontFamily: selectFontFamily,
  insertPlaceholder: insertPlaceholder,
  insertSignature: insertSignature,
  updateTextCasing: updateTextCasing,
  setActiveTextSetting: setActiveTextSetting
})(TextSettings);

var ZOOM_VALUES = [{
  value: '100',
  label: '100%'
}, {
  value: '90',
  label: '90%'
}, {
  value: '80',
  label: '80%'
}, {
  value: '70',
  label: '70%'
}, {
  value: '60',
  label: '60%'
}, {
  value: '50',
  label: '50%'
}, {
  value: '40',
  label: '40%'
}, {
  value: '30',
  label: '30%'
}, {
  value: '20',
  label: '20%'
}, {
  value: '10',
  label: '10%'
}];

var ChromePill = function (_a) {
  var duplicateElement = _a.duplicateElement,
      layerDown = _a.layerDown,
      layerUp = _a.layerUp,
      removeElement = _a.removeElement,
      setActiveImageSetting = _a.setActiveImageSetting,
      setActiveTextSetting = _a.setActiveTextSetting,
      openElementSettingsDrawer = _a.openElementSettingsDrawer,
      openElementInsertDrawer = _a.openElementInsertDrawer,
      deleteFullBleedBackgroundImage = _a.deleteFullBleedBackgroundImage,
      activeElement = _a.activeElement,
      editing = _a.editing,
      selectedFullBleed = _a.selectedFullBleed,
      selectedElement = _a.selectedElement,
      setEditing = _a.setEditing,
      addElement = _a.addElement,
      setShouldReplaceSelectedImage = _a.setShouldReplaceSelectedImage;
  var isLayoutElement = !(selectedElement === null || selectedElement === void 0 ? void 0 : selectedElement.draggable);
  var view = editing !== 'fullbleed' ? {
    title: 'Edit Full Bleed',
    icon: 'fullBleed',
    onClick: function () {
      setEditing('fullbleed');
      openElementSettingsDrawer('fullbleed');
    },
    isActive: false
  } : {
    title: 'Edit Panel',
    icon: 'panelMode',
    onClick: function () {
      setEditing('panel');
      openElementSettingsDrawer('panel');
    },
    isActive: false
  };
  var elementSettings = isLayoutElement ? [{
    title: 'Delete',
    icon: 'delete',
    onClick: function () {
      removeElement();
      openElementSettingsDrawer('panel');
    }
  }] : [{
    title: 'Delete',
    icon: 'delete',
    onClick: function () {
      removeElement();
      openElementSettingsDrawer('panel');
    }
  }, {
    title: 'Duplicate',
    icon: 'copy',
    onClick: function () {
      duplicateElement();
      (activeElement === null || activeElement === void 0 ? void 0 : activeElement.type) === 'image' ? setActiveImageSetting(null) : setActiveTextSetting(null);
    }
  }, {
    title: 'Layer Up',
    icon: 'layerUp',
    onClick: function () {
      return layerUp(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location);
    },
    isActive: false
  }, {
    title: 'Layer Down',
    icon: 'layerDown',
    onClick: function () {
      return layerDown(activeElement === null || activeElement === void 0 ? void 0 : activeElement.location);
    },
    isActive: false
  }];
  var panelSettings = [{
    title: 'Add Panel Layout',
    icon: 'template',
    onClick: function () {
      openElementInsertDrawer('layouts');
    },
    isActive: false
  }, {
    title: 'Add Panel Image',
    icon: 'image',
    onClick: function () {
      setShouldReplaceSelectedImage(true);
      openElementInsertDrawer('images');
      addElement('image', true);
      openElementSettingsDrawer('image');
    },
    isActive: false
  }, {
    title: 'Add Panel Text',
    icon: 'fullBleedText',
    onClick: function () {
      setShouldReplaceSelectedImage(false);
      openElementSettingsDrawer('text');
      addElement('text', true);
    },
    isActive: false
  }];
  var fullBleedSettings = [{
    title: 'Add Full Bleed Image',
    icon: 'fullBleedImage',
    onClick: function () {
      return openElementInsertDrawer('images');
    },
    isActive: false
  }, {
    title: 'Delete Full Bleed Image',
    icon: 'delete',
    onClick: function () {
      return deleteFullBleedBackgroundImage();
    },
    isActive: false
  }];

  var getPillSettings = function (editing) {
    var _a;

    var isOnInsidePanel = ((_a = selectedFullBleed === null || selectedFullBleed === void 0 ? void 0 : selectedFullBleed.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'inside';
    var settings = isOnInsidePanel ? [view] : [];

    switch (editing) {
      case 'element':
        return __spread(elementSettings, settings);

      case 'panel':
        return __spread(panelSettings, settings);

      case 'fullbleed':
        return __spread(fullBleedSettings, settings);
    }
  };

  return jsx(Pill, {
    items: __spread(getPillSettings(editing))
  });
};

var ChromePill$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    activeElement: editor.activeElement,
    editing: editor.editing,
    selectedFullBleed: selectedFullBleed(editor),
    selectedElement: selectedElement(editor)
  };
}, {
  addElement: addElement,
  removeElement: removeElement,
  duplicateElement: duplicateElement,
  layerUp: layerUp,
  layerDown: layerDown,
  setEditing: setEditing,
  deleteFullBleedBackgroundImage: deleteFullBleedBackgroundImage,
  setActiveImageSetting: setActiveImageSetting,
  setActiveTextSetting: setActiveTextSetting,
  openElementSettingsDrawer: openElementSettingsDrawer,
  openElementInsertDrawer: openElementInsertDrawer,
  setShouldReplaceSelectedImage: setShouldReplaceSelectedImage
})(ChromePill);

var PanelElementSidebar = function (props) {
  var panelOptions = props.panelOptions,
      helpIcon = props.helpIcon;

  var _a = __read(useState(-1), 2),
      sidebarHoverIndex = _a[0],
      setSidebarHoverIndex = _a[1];

  var tooltipVariants = {
    hoverOn: {
      opacity: 1
    },
    hoverOff: {
      opacity: 0
    }
  };
  return jsx(Sidebar, {
    position: "left",
    zIndex: 2004,
    width: "70px"
  }, jsx(Div, {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column"
  }, jsx(Section, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  }, jsx(Span, {
    inset: {
      vertical: 'x2'
    }
  }, jsx(Icon, {
    name: 'socLogo',
    size: "medium",
    primaryColor: "primaryBrand"
  })), jsx(Span, null, jsx(IconLink, {
    icon: "hamburger",
    fill: 'primaryBodyText',
    size: "small" // onClick={mainMenuAction}
    ,
    onClick: function () {
      return console.log('main');
    }
  }))), jsx(Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, panelOptions.map(function (option, index) {
    return jsx(React.Fragment, null, jsx(Flex, {
      key: index,
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      onHoverStart: function () {
        setSidebarHoverIndex(index + 1);
      },
      onHoverEnd: function () {
        return setSidebarHoverIndex(-1);
      }
    }, jsx(IconLink, {
      hasBackgroundColor: option.isActive,
      onClick: option.onClick,
      icon: option.icon,
      title: option.title,
      size: "small",
      isStacked: true,
      isActive: option.isActive
    }), sidebarHoverIndex === index + 1 && jsx(Flex, {
      position: "absolute",
      left: "75px",
      variants: tooltipVariants,
      animate: sidebarHoverIndex ? 'hoverOn' : 'hoverOff',
      initial: 'hoverOff',
      transition: {
        ease: 'easeIn',
        duration: 0.2
      }
    }, jsx(Tooltip, {
      direction: "left",
      title: "Add " + option.title,
      background: "dark"
    }))), jsx(Spacer, {
      space: 'x4'
    }));
  })), jsx(Section, null, helpIcon)));
};

var ChromeSidebar = function (_a) {
  var helpIcon = _a.helpIcon,
      addElement = _a.addElement,
      closeElementInsertDrawer = _a.closeElementInsertDrawer,
      openElementSettingsDrawer = _a.openElementSettingsDrawer,
      openElementInsertDrawer = _a.openElementInsertDrawer,
      isElementInsertOpen = _a.isElementInsertOpen,
      elementInsertDrawerType = _a.elementInsertDrawerType,
      setShouldReplaceSelectedImage = _a.setShouldReplaceSelectedImage;
  var panelOptions = [{
    title: 'Image',
    icon: 'image',
    onClick: function () {
      isElementInsertOpen ? closeElementInsertDrawer() : openElementInsertDrawer('images');
    },
    isActive: elementInsertDrawerType === 'images' && isElementInsertOpen ? true : false
  }, {
    title: 'Text',
    icon: 'textBox',
    onClick: function () {
      setShouldReplaceSelectedImage(false);
      addElement('text');
      closeElementInsertDrawer();
      openElementSettingsDrawer('text');
    }
  }, {
    title: 'Template',
    icon: 'template',
    onClick: function () {
      openElementInsertDrawer('layouts');
    },
    isActive: elementInsertDrawerType === 'layouts' && isElementInsertOpen ? true : false
  }];
  return jsx(PanelElementSidebar, {
    helpIcon: helpIcon,
    panelOptions: panelOptions
  });
};

var ChromeSidebar$1 = connect(function (_a) {
  var editorChrome = _a.editorChrome;
  return {
    isElementInsertOpen: editorChrome.isElementInsertOpen,
    elementInsertDrawerType: editorChrome.elementInsertDrawerType
  };
}, {
  closeElementInsertDrawer: closeElementInsertDrawer,
  openElementSettingsDrawer: openElementSettingsDrawer,
  openElementInsertDrawer: openElementInsertDrawer,
  addElement: addElement,
  setShouldReplaceSelectedImage: setShouldReplaceSelectedImage
})(ChromeSidebar);

var ChromeUndoRedo = function (_a) {
  var editorRedo = _a.editorRedo,
      editorUndo = _a.editorUndo;

  var _b = __read(useState(-1), 2),
      undoRedoTooltip = _b[0],
      setUndoRedoTooltip = _b[1];

  var handleKeyDown = function (event) {
    var isMetaOrCtrl = event.metaKey || event.ctrlKey;
    var isShift = event.shiftKey;

    if (event.key === 'z' && isMetaOrCtrl && isShift || event.key === 'y' && isMetaOrCtrl) {
      return editorRedo();
    }

    if (event.key === 'z' && isMetaOrCtrl) {
      return editorUndo();
    }
  };

  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });
  return jsx(Flex, {
    position: "absolute"
  }, jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setUndoRedoTooltip(1);
    },
    onHoverEnd: function () {
      return setUndoRedoTooltip(-1);
    }
  }, jsx(IconLink, {
    onClick: function () {
      return editorUndo();
    },
    icon: 'undo',
    size: "small",
    fill: "primaryHeadingText"
  })), jsx(Spacer, {
    orientation: "horizontal",
    space: "x2"
  }), jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setUndoRedoTooltip(2);
    },
    onHoverEnd: function () {
      return setUndoRedoTooltip(-1);
    }
  }, jsx(IconLink, {
    onClick: function () {
      return editorRedo();
    },
    icon: 'redo',
    size: "small",
    fill: "primaryHeadingText"
  })), undoRedoTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    top: "-60px",
    left: undoRedoTooltip === 1 ? '-12px' : undefined,
    right: undoRedoTooltip === 2 ? '-12px' : undefined,
    animate: undoRedoTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "bottom",
    title: undoRedoTooltip === 1 ? 'Undo' : 'Redo'
  })));
};

var ChromeUndoRedo$1 = connect(null, {
  editorRedo: editorRedo,
  editorUndo: editorUndo
})(ChromeUndoRedo);

var PanelSettings = function (_a) {
  var setPanelBackground = _a.setPanelBackground,
      selectedPanel = _a.selectedPanel,
      panelLocation = _a.panelLocation;
  return jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, "Panel Settings:"), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, "Apply the following setting to your selected panel"), jsx(Div, {
    outset: {
      vertical: 'auto'
    }
  }, jsx(Settings, {
    sections: [{
      title: 'Panel Background',
      onClick: function () {},
      icon: 'colorPalette',
      settings: jsx(ColorPicker, {
        defaultColor: (selectedPanel === null || selectedPanel === void 0 ? void 0 : selectedPanel.backgroundColor) || {
          r: 255,
          g: 255,
          b: 255
        } // TODO add support for no color option
        ,
        onColorChange: function (color) {
          return setPanelBackground(color);
        },
        itemLocation: panelLocation,
        canRemoveColor: true
      })
    }]
  })));
};

var PanelSettings$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    selectedPanel: selectedPanel(editor),
    activeElement: editor.activeElement,
    card: editor.card,
    panelLocation: editor.panelLocation,
    fullBleedLocation: editor.fullBleedLocation
  };
}, {
  setPanelBackground: setPanelBackground
})(PanelSettings);

var LayoutSettings = function (_a) {
  var location = _a.location,
      onUpdatePosition = _a.onUpdatePosition,
      onUpdateSize = _a.onUpdateSize,
      x = _a.x,
      y = _a.y,
      height = _a.height,
      width = _a.width; // TODO - Bug is related to width/height and x/y being called in the same reducer
  // x updates, y then updates and re calls the reducer with the old x
  // Because the slider needs rounded decimals to prevent dragging beyond max point

  return jsx(Flex, {
    flexDirection: "column",
    inset: {
      bottom: 'x3'
    }
  }, jsx(VStack, {
    gap: "x2"
  }, jsx(Div, null, jsx(ElementIncrementSetting$1, {
    title: 'X',
    initial: x,
    min: 0,
    max: 100 - width * 100,
    callback: function (value) {
      return onUpdatePosition(location, value, undefined);
    },
    resetDependency: x
  })), jsx(Div, null, jsx(ElementIncrementSetting$1, {
    title: 'Y',
    initial: y,
    min: 0,
    max: 100 - height * 100,
    callback: function (value) {
      return onUpdatePosition(location, undefined, value);
    },
    resetDependency: y
  })), jsx(Div, null, jsx(ElementIncrementSetting$1, {
    title: 'Width',
    initial: width,
    min: 1,
    max: 100 - x * 100,
    callback: function (value) {
      return onUpdateSize(location, value, undefined);
    },
    resetDependency: width
  })), jsx(Div, null, jsx(ElementIncrementSetting$1, {
    title: 'Height',
    initial: height,
    min: 1,
    max: 100 - y * 100,
    callback: function (value) {
      return onUpdateSize(location, undefined, value);
    },
    resetDependency: height
  }))));
};

var CropSettings = function (_a) {
  var scale = _a.scale,
      x = _a.x,
      y = _a.y,
      onSelectImagePosition = _a.onSelectImagePosition,
      onSelectImageScale = _a.onSelectImageScale;
  return jsx(Flex, {
    flexDirection: "column",
    inset: {
      bottom: 'x3'
    }
  }, jsx(VStack, {
    gap: "x2"
  }, jsx(Div, null, jsx(ElementIncrementSetting$1, {
    title: 'X',
    initial: x,
    min: 0,
    max: 100,
    callback: function (value) {
      return onSelectImagePosition(value, undefined);
    },
    resetDependency: x
  })), jsx(Div, null, jsx(ElementIncrementSetting$1, {
    title: 'Y',
    initial: y,
    min: 0,
    max: 100,
    callback: function (value) {
      return onSelectImagePosition(undefined, value);
    },
    resetDependency: y
  })), jsx(Div, null, jsx(ElementIncrementSetting$1, {
    title: 'Scale',
    initial: scale !== null && scale !== void 0 ? scale : 1,
    min: 50,
    max: 500,
    callback: function (value) {
      return onSelectImageScale(value);
    },
    resetDependency: scale
  }))));
};

var RotateSettings = function (_a) {
  var rotation = _a.rotation,
      location = _a.location,
      onUpdateRotation = _a.onUpdateRotation;
  return jsx(Flex, {
    flexDirection: "column",
    inset: {
      bottom: 'x3'
    }
  }, jsx(ElementIncrementSetting$1, {
    title: 'Rotation Degrees',
    initial: rotation / 100,
    min: -360,
    max: 360,
    callback: function (value) {
      return onUpdateRotation(location, value * 100);
    },
    sliderOrigin: "center"
  }));
};

var ImageSettings = function (props) {
  var location = props.location,
      title = props.title,
      subtitle = props.subtitle,
      imageScale = props.imageScale,
      imageX = props.imageX,
      imageY = props.imageY,
      elementHeight = props.elementHeight,
      elementWidth = props.elementWidth,
      elementX = props.elementX,
      elementY = props.elementY,
      elementRotation = props.elementRotation,
      onUpdatePosition = props.onUpdatePosition,
      onSelectImagePosition = props.onSelectImagePosition,
      onSelectImageScale = props.onSelectImageScale,
      onUpdateSize = props.onUpdateSize,
      onUpdateRotation = props.onUpdateRotation,
      setActiveImageSetting = props.setActiveImageSetting,
      activeImageSetting = props.activeImageSetting,
      isLayoutElement = props.isLayoutElement;
  var nonLayoutElementSections = [{
    title: 'Layout',
    onClick: function () {
      return setActiveImageSetting(null);
    },
    icon: 'sliderHorizontal',
    settings: jsx(LayoutSettings, {
      width: elementWidth,
      height: elementHeight,
      x: elementX,
      y: elementY,
      location: location,
      onUpdatePosition: onUpdatePosition,
      onUpdateSize: onUpdateSize
    })
  }, {
    title: 'Rotate',
    icon: 'cropRotate',
    onClick: function () {
      return setActiveImageSetting(null);
    },
    settings: jsx(RotateSettings, {
      location: location,
      rotation: elementRotation,
      onUpdateRotation: onUpdateRotation
    })
  }];
  var layoutElementSections = [{
    title: 'Crop',
    onClick: activeImageSetting === 'crop' ? function () {
      return setActiveImageSetting(null);
    } : function () {
      return setActiveImageSetting('crop');
    },
    icon: 'crop',
    settings: jsx(CropSettings, {
      onSelectImagePosition: onSelectImagePosition,
      onSelectImageScale: onSelectImageScale,
      x: imageX,
      y: imageY,
      scale: imageScale
    })
  }];
  return jsx(Flex, {
    inset: "x1",
    flexDirection: "column",
    height: "100%"
  }, jsx(Text, {
    type: "largeBody",
    weight: "semiBold",
    color: "primaryHeading"
  }, title), jsx(Text, {
    type: "caption",
    weight: "thin"
  }, subtitle), jsx(Div, {
    outset: {
      vertical: 'auto'
    }
  }, jsx(Settings, {
    sections: !isLayoutElement ? __spread(nonLayoutElementSections, layoutElementSections) : __spread(layoutElementSections)
  })));
};

var ImageSettings$1 = connect(function (_a) {
  var editorChrome = _a.editorChrome;
  return {
    activeImageSetting: editorChrome.activeImageSetting
  };
}, {
  setActiveImageSetting: setActiveImageSetting
})(ImageSettings);

var FullBleedSettings = function (_a) {
  var _b;

  var selectedFullBleed = _a.selectedFullBleed,
      fullBleedLocation = _a.fullBleedLocation,
      updateFullBleedBackgroundImagePosition = _a.updateFullBleedBackgroundImagePosition,
      updateFullBleedBackgroundImageScale = _a.updateFullBleedBackgroundImageScale,
      updateFullBleedBackgroundElementPosition = _a.updateFullBleedBackgroundElementPosition,
      updateFullBleedBackgroundElementSize = _a.updateFullBleedBackgroundElementSize,
      updateFullBleedBackgroundElementRotation = _a.updateFullBleedBackgroundElementRotation;
  var backgroundElement = selectedFullBleed === null || selectedFullBleed === void 0 ? void 0 : selectedFullBleed.backgroundElement;
  return jsx(VStack, {
    gap: "x3"
  }, ((_b = backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) === null || _b === void 0 ? void 0 : _b.image) ? jsx(React.Fragment, null, jsx(ImageSettings$1, {
    title: "Background Image Settings:",
    subtitle: "Apply the following settings to your background image",
    location: fullBleedLocation !== null && fullBleedLocation !== void 0 ? fullBleedLocation : 0,
    elementY: backgroundElement.y,
    elementX: backgroundElement.x,
    elementHeight: backgroundElement.height,
    elementWidth: backgroundElement.width,
    elementRotation: backgroundElement.rotation,
    imageY: backgroundElement.image.position.y,
    imageX: backgroundElement.image.position.x,
    imageScale: backgroundElement.image.scale,
    onUpdateSize: function (_location, width, height) {
      return updateFullBleedBackgroundElementSize(width, height);
    },
    onUpdateRotation: function (_location, rotation) {
      return updateFullBleedBackgroundElementRotation(rotation);
    },
    onUpdatePosition: function (_location, x, y) {
      return updateFullBleedBackgroundElementPosition(x, y);
    },
    onSelectImageScale: updateFullBleedBackgroundImageScale,
    onSelectImagePosition: updateFullBleedBackgroundImagePosition,
    isLayoutElement: false
  })) : jsx(Text, {
    type: "body"
  }, "There is no background image"));
};

var FullBleedSettings$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    selectedFullBleed: selectedFullBleed(editor),
    fullBleedLocation: editor.fullBleedLocation
  };
}, {
  updateFullBleedBackgroundImagePosition: updateFullBleedBackgroundImagePosition,
  updateFullBleedBackgroundImageScale: updateFullBleedBackgroundImageScale,
  updateFullBleedBackgroundElementPosition: updateFullBleedBackgroundElementPosition,
  updateFullBleedBackgroundElementSize: updateFullBleedBackgroundElementSize,
  updateFullBleedBackgroundElementRotation: updateFullBleedBackgroundElementRotation
})(FullBleedSettings);

var ImageElementSettings = function (props) {
  var _a, _b, _c, _d, _e, _f, _g;

  var selectedElement = props.selectedElement,
      activeElement = props.activeElement,
      selectImagePosition = props.selectImagePosition,
      selectImageScale = props.selectImageScale,
      updateElementRotation = props.updateElementRotation,
      updateElementSize = props.updateElementSize,
      updateElementPosition = props.updateElementPosition;
  var scale = selectedElement ? (_b = (_a = selectedElement.image) === null || _a === void 0 ? void 0 : _a.scale) !== null && _b !== void 0 ? _b : 1 : 0;
  var x = selectedElement ? (_d = (_c = selectedElement.image) === null || _c === void 0 ? void 0 : _c.position.x) !== null && _d !== void 0 ? _d : 0.5 : 0;
  var y = selectedElement ? (_f = (_e = selectedElement.image) === null || _e === void 0 ? void 0 : _e.position.y) !== null && _f !== void 0 ? _f : 0.5 : 0;
  var rotation = selectedElement ? selectedElement.rotation : 0;
  var location = (_g = activeElement.location) !== null && _g !== void 0 ? _g : 0;
  return selectedElement ? jsx(ImageSettings$1, {
    title: 'Image Settings',
    subtitle: 'Apply the following setting to your selected image',
    location: location,
    imageScale: scale,
    imageX: x,
    imageY: y,
    elementRotation: rotation,
    elementHeight: selectedElement.height,
    elementWidth: selectedElement.width,
    elementX: selectedElement.x,
    elementY: selectedElement.y,
    isLayoutElement: !selectedElement.draggable || false,
    onSelectImagePosition: selectImagePosition,
    onSelectImageScale: selectImageScale,
    onUpdatePosition: updateElementPosition,
    onUpdateRotation: updateElementRotation,
    onUpdateSize: updateElementSize
  }) : jsx("div", null, "You don't have an image selected");
};

var ImageElementSettings$1 = connect(function (_a) {
  var editorChrome = _a.editorChrome,
      editor = _a.editor;
  return {
    selectedElement: selectedElement(editor),
    activeImageSetting: editorChrome.activeImageSetting,
    activeElement: editor.activeElement
  };
}, {
  rotateElement: updateElementRotation,
  selectImagePosition: selectImagePosition,
  selectImageScale: selectImageScale,
  updateElementRotation: updateElementRotation,
  updateElementSize: updateElementSize,
  updateElementPosition: updateElementPosition,
  setActiveImageSetting: setActiveImageSetting
})(ImageElementSettings);

var EditorChrome = function (_a) {
  var children = _a.children,
      layouts = _a.layouts,
      images = _a.images,
      onUploadImages = _a.onUploadImages,
      fonts = _a.fonts,
      signatures = _a.signatures,
      placeholders = _a.placeholders,
      handleChangeView = _a.handleChangeView,
      helpIcon = _a.helpIcon,
      isElementInsertOpen = _a.isElementInsertOpen,
      elementSettingsDrawerType = _a.elementSettingsDrawerType,
      elementInsertDrawerType = _a.elementInsertDrawerType,
      closeElementInsertDrawer = _a.closeElementInsertDrawer,
      openElementSettingsDrawer = _a.openElementSettingsDrawer,
      isElementSettingsOpen = _a.isElementSettingsOpen,
      closeElementSettingsDrawer = _a.closeElementSettingsDrawer,
      contextZones = _a.contextZones,
      theme = _a.theme;
  var editorWrapperRef = useRef(null);

  var _b = __read(useState(5), 2),
      activeZoomIndex = _b[0],
      setActiveZoomIndex = _b[1];

  var renderElementInsertDrawerContent = function (insertType) {
    switch (insertType) {
      case 'images':
        return jsx(Images$1, {
          images: images,
          onUploadImages: onUploadImages,
          loaderComponent: jsx(LoadingSpinner, {
            size: "medium"
          })
        });

      case 'layouts':
        return jsx(Layouts$1, {
          layouts: layouts
        });

      default:
        return jsx(React.Fragment, null);
    }
  };

  var renderSettingsDrawerContent = function (settingType) {
    switch (settingType) {
      case 'image':
        return jsx(ImageElementSettings$1, null);

      case 'text':
        return jsx(TextSettings$1, null);

      case 'panel':
        return jsx(PanelSettings$1, null);

      case 'fullbleed':
        return jsx(FullBleedSettings$1, null);

      default:
        return jsx(React.Fragment, null);
    }
  };

  return jsx(QuantumThemeWrapper, {
    theme: theme
  }, jsx(EditorChromeProvider, {
    value: {
      layouts: layouts,
      images: images,
      fonts: fonts,
      signatures: signatures,
      placeholders: placeholders
    }
  }, jsx(Flex, {
    position: "absolute",
    left: 0,
    overflow: "hidden"
  }, jsx(ChromeSidebar$1, {
    helpIcon: helpIcon
  }), jsx(Drawer, {
    isTabHidden: true,
    zIndex: 1000,
    location: "left",
    offset: 60,
    openValue: 298,
    isOpen: isElementInsertOpen,
    onClick: function () {
      return closeElementInsertDrawer();
    }
  }, jsx(Flex, {
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    inset: "x1"
  }, renderElementInsertDrawerContent(elementInsertDrawerType)), jsx("button", {
    onClick: handleChangeView
  }, "Change View")), jsx(Section, {
    backgroundColor: "background",
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  }, jsx(ChromePill$1, null), jsx(Div, {
    outset: {
      top: 'x8',
      bottom: '60px'
    },
    ref: editorWrapperRef,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: ZOOM_VALUES[activeZoomIndex].value + "vw",
    height: ZOOM_VALUES[activeZoomIndex].value + "vh"
  }, children), jsx(Div, {
    position: "absolute",
    bottom: "124px",
    zIndex: 10000
  }, jsx(Zoom, {
    background: "foreground",
    items: ZOOM_VALUES,
    onChange: function (index) {
      setActiveZoomIndex(index);
    },
    selectedOptionIndex: activeZoomIndex
  }))), jsx(Drawer, {
    isTabHidden: false,
    zIndex: 1000,
    location: "right",
    openValue: 315,
    isOpen: isElementSettingsOpen,
    onClick: function () {
      return isElementSettingsOpen ? closeElementSettingsDrawer() : typeof elementSettingsDrawerType === 'string' && openElementSettingsDrawer(elementSettingsDrawerType);
    }
  }, renderSettingsDrawerContent(elementSettingsDrawerType))), jsx(Flex, {
    width: "100%",
    height: "60px",
    backgroundColor: "foreground",
    position: "fixed",
    bottom: "0px",
    justifyContent: "center",
    alignItems: "center"
  }, jsx(Flex, {
    width: "calc(100% / 3)",
    justifyContent: "center",
    alignItems: "center"
  }), jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    width: "calc(100% / 3)"
  }, jsx(ChromeUndoRedo$1, null)), jsx(Flex, {
    width: "calc(100% / 3)",
    justifyContent: "center",
    alignItems: "center",
    inset: {
      right: 'x2'
    }
  }, contextZones.primary)), jsx("button", {
    onClick: handleChangeView
  }, "Change View")));
};

var EditorChrome$1 = connect(function (_a) {
  var editorChrome = _a.editorChrome;
  return {
    isElementInsertOpen: editorChrome.isElementInsertOpen,
    isElementSettingsOpen: editorChrome.isElementSettingsOpen,
    elementInsertDrawerType: editorChrome.elementInsertDrawerType,
    elementSettingsDrawerType: editorChrome.elementSettingsDrawerType,
    activeImageSetting: editorChrome.activeImageSetting
  };
}, {
  setPanelBackground: setPanelBackground,
  selectFullBleed: selectFullBleed,
  openElementInsertDrawer: openElementInsertDrawer,
  closeElementInsertDrawer: closeElementInsertDrawer,
  openElementSettingsDrawer: openElementSettingsDrawer,
  closeElementSettingsDrawer: closeElementSettingsDrawer,
  setActiveImageSetting: setActiveImageSetting,
  setActiveTextSetting: setActiveTextSetting
})(EditorChrome);

var EditorContext = /*#__PURE__*/createContext({
  panelView: 'fullbleed',
  currentIndex: 0,
  editorId: 0,
  isPreview: false
});
var EditorProvider = EditorContext.Provider;
var EditorConsumer = EditorContext.Consumer;

var imageIsCached = function (src) {
  var mutableImage = new Image();
  mutableImage.src = src;
  return mutableImage.complete;
};

var IndicatorModeControl = function (_a) {
  var onActiveElementDrag = _a.onActiveElementDrag,
      onActiveElementDelete = _a.onActiveElementDelete,
      onActiveElementReplace = _a.onActiveElementReplace,
      mode = _a.mode,
      elementType = _a.elementType,
      shouldReplaceSelectedImage = _a.shouldReplaceSelectedImage;

  var _b = __read(useState(-1), 2),
      activeIndicatorTooltip = _b[0],
      setActiveIndicatorTooltip = _b[1];

  useEffect(function () {
    setActiveIndicatorTooltip(-1);
  }, [shouldReplaceSelectedImage]);
  return jsx(Flex, {
    width: '100%',
    position: 'absolute',
    bottom: '-32px',
    zIndex: 10,
    justifyContent: "center"
  }, !shouldReplaceSelectedImage ? jsx(Flex, {
    width: "fit-content",
    position: "absolute",
    borderRadius: "circle",
    backgroundColor: "foreground",
    inset: "x1"
  }, jsx(HStack, {
    gap: 'x3',
    justify: 'center',
    shouldWrap: false
  }, jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(1);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'delete',
    size: 'xSmall',
    isActive: mode === 'move',
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementDelete();
    }
  })), elementType === 'image' && jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(2);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'replaceImage',
    size: 'xSmall',
    isActive: mode === 'replace',
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementReplace(true);
    }
  })), jsx(Span, {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    onHoverStart: function () {
      return setActiveIndicatorTooltip(3);
    },
    onHoverEnd: function () {
      return setActiveIndicatorTooltip(-1);
    }
  }, jsx(IconLink, {
    icon: 'drag',
    size: 'xSmall',
    isActive: mode === 'move',
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementDrag();
    }
  }))), activeIndicatorTooltip >= 1 && jsx(Flex, {
    position: "absolute",
    bottom: "-44px",
    left: activeIndicatorTooltip === 1 ? '-8px' : activeIndicatorTooltip === 2 ? '36px' : undefined,
    right: activeIndicatorTooltip === 3 ? '-8px' : undefined,
    animate: activeIndicatorTooltip ? {
      opacity: 1
    } : {
      opacity: 0
    },
    initial: 'hoverOff',
    transition: {
      ease: 'easeIn',
      duration: 0.2
    }
  }, jsx(Tooltip, {
    background: "dark",
    direction: "top",
    title: activeIndicatorTooltip === 1 ? 'Delete' : activeIndicatorTooltip === 2 ? 'Replace' : 'Move'
  }))) : jsx(Flex, {
    justifyContent: "center",
    alignItems: "center",
    position: 'relative',
    bottom: '-32px'
  }, jsx(Button, {
    type: "shadow",
    size: "xSmall",
    onMouseEvent: function (e) {
      e.stopPropagation();
      onActiveElementReplace(false);
    }
  }, "Done")));
};

var MoveableWrapper = function (_a) {
  var parentHeight = _a.parentHeight,
      parentWidth = _a.parentWidth,
      parentId = _a.parentId,
      children = _a.children,
      position = _a.position,
      rotation = _a.rotation,
      size = _a.size,
      isSelected = _a.isSelected,
      isEditable = _a.isEditable,
      onUpdatePosition = _a.onUpdatePosition,
      onUpdateRotation = _a.onUpdateRotation,
      onUpdateSize = _a.onUpdateSize,
      onActiveElementDelete = _a.onActiveElementDelete,
      onActiveElementDrag = _a.onActiveElementDrag,
      onActiveElementReplace = _a.onActiveElementReplace,
      elementType = _a.elementType,
      shouldReplaceSelectedImage = _a.shouldReplaceSelectedImage,
      elementLocation = _a.elementLocation;

  var getParent = function () {
    return parentWidth && parentHeight ? {
      width: parentWidth,
      height: parentHeight
    } : {
      width: 0,
      height: 0
    };
  };

  var xToPixels = function (x) {
    return getParent().width * x;
  };

  var yToPixels = function (y) {
    return getParent().height * y;
  };

  var widthToPixels = function (widthPct) {
    return getParent().width * widthPct;
  };

  var heightToPixels = function (heighPct) {
    return getParent().height * heighPct;
  };

  var widthToPercent = function (width) {
    return width / getParent().width;
  };

  var heightToPercent = function (height) {
    console.log('height', height);
    return height / getParent().height;
  };

  var xToPercentage = function (x) {
    var fixedX = parseInt(x.toFixed(8));
    var fixedParentWidth = parseInt(getParent().width.toFixed(8));
    var xWithoutNegatives = fixedX < 0 ? 0 : fixedX;
    var xPercentage = xWithoutNegatives / fixedParentWidth;
    return xPercentage;
  };

  var yToPercentage = function (y) {
    var fixedY = parseInt(y.toFixed(8));
    var fixedParentHeight = parseInt(getParent().height.toFixed(8));
    var yWithoutNegatives = fixedY < 0 ? 0 : fixedY;
    var yPercentage = yWithoutNegatives / fixedParentHeight;
    return yPercentage;
  };

  var _b = __read(useState(null), 2),
      target = _b[0],
      setTarget = _b[1];

  var _c = __read(React.useState({
    translate: [0, 0],
    rotate: rotation
  }), 1),
      frame = _c[0];

  useEffect(function () {
    setTarget(document.querySelector(".target-" + parentId + " "));
  }, [parentId]);
  var height = heightToPixels(size.height);
  var width = widthToPixels(size.width);
  var x = xToPixels(position.x) - frame.translate[0];
  var y = yToPixels(position.y) - frame.translate[1];
  return jsx(React.Fragment, null, target && isSelected && isEditable && jsx(Moveable, {
    draggable: true,
    resizable: true,
    rotatable: true,
    origin: false,
    keepRatio: false // Keep ratio for images?
    ,
    throttleResize: 1,
    edge: false,
    bounds: {
      left: 0,
      top: 0,
      right: parentWidth,
      bottom: parentHeight
    },
    target: target,
    zoom: 1,
    snappable: true,
    onDragStart: function (_a) {
      var set = _a.set;
      set(frame.translate);
    },
    onDrag: function (_a) {
      var beforeTranslate = _a.beforeTranslate;
      frame.translate = beforeTranslate;
    },
    onDragEnd: function (_a) {
      var currentTarget = _a.currentTarget;
      var leftTopCornerLeftPosition = currentTarget.getRect().pos1[0];
      var leftTopCornerTopPosition = currentTarget.getRect().pos1[1];
      onUpdatePosition(xToPercentage(leftTopCornerLeftPosition), yToPercentage(leftTopCornerTopPosition));
    },
    onResizeStart: function (_a) {
      var setOrigin = _a.setOrigin,
          dragStart = _a.dragStart;
      setOrigin(['%', '%']);
      dragStart && dragStart.set(frame.translate);
    },
    onResize: function (_a) {
      var target = _a.target,
          drag = _a.drag,
          width = _a.width,
          height = _a.height;
      frame.translate = drag.beforeTranslate;
      target.style.width = width + "px";
      target.style.height = height + "px";
    },
    onResizeEnd: function (_a) {
      var currentTarget = _a.currentTarget;
      var leftTopCornerLeftPosition = currentTarget.getRect().pos1[0];
      var leftTopCornerTopPosition = currentTarget.getRect().pos1[1];
      var width = currentTarget.state.width;
      var height = currentTarget.state.height;
      onUpdatePosition(xToPercentage(leftTopCornerLeftPosition), yToPercentage(leftTopCornerTopPosition));
      onUpdateSize(widthToPercent(width), heightToPercent(height));
    },
    throttleRotate: 0,
    rotationPosition: 'bottom-right',
    onRotateStart: function (_a) {
      var set = _a.set;
      set(frame.rotate);
    },
    onRotate: function (_a) {
      var beforeRotate = _a.beforeRotate;
      frame.rotate = beforeRotate;
    },
    onRotateEnd: function () {
      onUpdateRotation(elementLocation, frame.rotate);
    },
    onRender: function (_a) {
      var target = _a.target;
      target.style.transform = "translate(" + frame.translate[0] + "px, " + frame.translate[1] + "px) rotate(" + frame.rotate + "deg)";
    }
  }), jsx(Div, {
    position: "absolute",
    top: y + "px",
    left: x + "px",
    transform: "rotate(" + frame.rotate + "deg)",
    width: width + "px",
    height: height + "px",
    className: "target-" + parentId,
    id: "moveable-wrapper",
    zIndex: position.z,
    transformOrigin: "top left"
  }, children, isSelected && isEditable && jsx(IndicatorModeControl, {
    onActiveElementDelete: onActiveElementDelete,
    onActiveElementReplace: onActiveElementReplace,
    onActiveElementDrag: onActiveElementDrag,
    elementType: elementType,
    shouldReplaceSelectedImage: shouldReplaceSelectedImage
  })));
};

var styles = {
  elementContainer: function (props, activeColor, inactiveColor) {
    return /*#__PURE__*/css(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: auto;\n    outline: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBlbGVtZW50Q29udGFpbmVyOiBmdW5jdGlvbiAocHJvcHMsIGFjdGl2ZUNvbG9yLCBpbmFjdGl2ZUNvbG9yKSB7IHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMSB8fCAodGVtcGxhdGVPYmplY3RfMSA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XFxuICAgIGRpc3BsYXk6IGZsZXg7XFxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XFxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XFxuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgb3V0bGluZTogXCIsIFwiO1xcbiAgXCJdLCBbXCJcXG4gICAgaGVpZ2h0OiAxMDAlO1xcbiAgICB3aWR0aDogMTAwJTtcXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgb3ZlcmZsb3c6IGF1dG87XFxuICAgIG91dGxpbmU6IFwiLFxyXG4gICAgICAgIFwiO1xcbiAgXCJdKSksIHByb3BzLnBhbmVsTG9jYXRpb24gIT09IG51bGwgJiYgcHJvcHMuc2hvd0JvcmRlclxyXG4gICAgICAgID8gXCIxcHggZGFzaGVkIFwiICsgKHByb3BzLmVsZW1lbnQuaXNTZWxlY3RlZCA/IGFjdGl2ZUNvbG9yIDogaW5hY3RpdmVDb2xvcilcclxuICAgICAgICA6ICdub25lJyk7IH0sXHJcbn07XHJcbnZhciB0ZW1wbGF0ZU9iamVjdF8xO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */")], ["\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    overflow: auto;\n    outline: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QgfSBmcm9tIFwidHNsaWJcIjtcclxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBlbGVtZW50Q29udGFpbmVyOiBmdW5jdGlvbiAocHJvcHMsIGFjdGl2ZUNvbG9yLCBpbmFjdGl2ZUNvbG9yKSB7IHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMSB8fCAodGVtcGxhdGVPYmplY3RfMSA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICBoZWlnaHQ6IDEwMCU7XFxuICAgIHdpZHRoOiAxMDAlO1xcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XFxuICAgIGRpc3BsYXk6IGZsZXg7XFxuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XFxuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XFxuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xcbiAgICBvdmVyZmxvdzogYXV0bztcXG4gICAgb3V0bGluZTogXCIsIFwiO1xcbiAgXCJdLCBbXCJcXG4gICAgaGVpZ2h0OiAxMDAlO1xcbiAgICB3aWR0aDogMTAwJTtcXG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xcbiAgICBkaXNwbGF5OiBmbGV4O1xcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcXG4gICAgb3ZlcmZsb3c6IGF1dG87XFxuICAgIG91dGxpbmU6IFwiLFxyXG4gICAgICAgIFwiO1xcbiAgXCJdKSksIHByb3BzLnBhbmVsTG9jYXRpb24gIT09IG51bGwgJiYgcHJvcHMuc2hvd0JvcmRlclxyXG4gICAgICAgID8gXCIxcHggZGFzaGVkIFwiICsgKHByb3BzLmVsZW1lbnQuaXNTZWxlY3RlZCA/IGFjdGl2ZUNvbG9yIDogaW5hY3RpdmVDb2xvcilcclxuICAgICAgICA6ICdub25lJyk7IH0sXHJcbn07XHJcbnZhciB0ZW1wbGF0ZU9iamVjdF8xO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */")])), props.panelLocation !== null && props.showBorder ? "1px dashed " + (props.element.isSelected ? activeColor : inactiveColor) : 'none');
  }
};
var templateObject_1$1;

var noSettingsEnabled = function (activeSetting) {
  return activeSetting === null;
};

var Element = function (props) {
  var elementId = props.elementId,
      originalHeight = props.height,
      originalWidth = props.width,
      originalX = props.x,
      originalY = props.y,
      originalZ = props.z,
      panelSize = props.panelSize,
      children = props.children,
      element = props.element,
      _a = props.isFullBleedBackground,
      isFullBleedBackground = _a === void 0 ? false : _a,
      panelLocation = props.panelLocation,
      updateElementPosition = props.updateElementPosition,
      updateElementSize = props.updateElementSize,
      enableSelectingElements = props.enableSelectingElements,
      selectElement = props.selectElement,
      activeImageSetting = props.activeImageSetting,
      activeTextSetting = props.activeTextSetting,
      elementSettingsDrawerType = props.elementSettingsDrawerType,
      onEdit = props.onEdit,
      canSelectElements = props.canSelectElements,
      editing = props.editing,
      originalRotation = props.rotation,
      updateFullBleedBackgroundElementPosition = props.updateFullBleedBackgroundElementPosition,
      updateFullBleedBackgroundElementSize = props.updateFullBleedBackgroundElementSize,
      updateElementRotation = props.updateElementRotation,
      shouldReplaceSelectedImage = props.shouldReplaceSelectedImage,
      setShouldReplaceSelectedImage = props.setShouldReplaceSelectedImage,
      removeElement = props.removeElement,
      setActiveImageSetting = props.setActiveImageSetting,
      setActiveTextSetting = props.setActiveTextSetting,
      openElementInsertDrawer = props.openElementInsertDrawer;
  var width = originalWidth <= 1 ? originalWidth : 1;
  var height = originalHeight <= 1 ? originalHeight : 1;
  var x = originalX >= 0 ? originalX : 0;
  var y = originalY >= 0 ? originalY : 0;
  var z = originalZ && originalZ >= 0 ? originalZ : 0; // TODO remove optional type and make z required

  var rotation = originalRotation || 0;
  var activeSetting = elementSettingsDrawerType === 'image' || isFullBleedBackground ? activeImageSetting : activeTextSetting;

  var _b = useColorSwatch(),
      success = _b.success,
      grayScale = _b.grayScale;

  var isElementLocked = function (isFullBleedBackground) {
    if (activeElement.type === 'text') {
      return element.movingProhibited || !element.draggable || !element.isSelected;
    }

    if (isFullBleedBackground) {
      return element.locked || editing !== 'fullbleed' || !noSettingsEnabled(activeSetting);
    }

    return element.movingProhibited || !element.draggable || !element.isSelected || !noSettingsEnabled(activeSetting);
  };

  var canElementBeSelected = function (isFullBleedBackground) {
    if (isFullBleedBackground) {
      return canSelectElements && editing === 'fullbleed';
    }

    return canSelectElements && !element.isSelected && panelLocation !== null;
  };

  var canElementBeEdited = function (isFullBleedBackground) {
    if (isFullBleedBackground) {
      return canSelectElements && editing === 'fullbleed';
    }

    return element.isSelected && canSelectElements && panelLocation !== null && !element.editingProhibited;
  };

  var activeElement = {
    location: element.location,
    type: !!element.image ? 'image' : !!element.text ? 'text' : null
  };

  var handleUpdatePosition = function (x, y) {
    if (isFullBleedBackground) {
      enableSelectingElements();
      updateFullBleedBackgroundElementPosition(x, y);
    } else {
      enableSelectingElements();
      updateElementPosition(element.location, x, y);
    }
  };

  var handleUpdateSize = function (width, height) {
    if (isFullBleedBackground) {
      enableSelectingElements();
      updateFullBleedBackgroundElementSize(width, height);
    } else {
      enableSelectingElements();
      updateElementSize(element.location, width, height);
    }
  };

  var handleElementOnClick = function (event, isFullBleedBackground) {
    event.stopPropagation();

    if (isFullBleedBackground) {
      onEdit();
      return;
    }

    if (canElementBeEdited(isFullBleedBackground)) {
      onEdit();
    }
  };

  var handleSelectElement = function (activeElement, panelLocation) {
    if (!element.draggable) {
      setShouldReplaceSelectedImage(true);
      setActiveImageSetting(null);
      selectElement(activeElement, panelLocation);
    } else {
      setShouldReplaceSelectedImage(false);
      setActiveImageSetting(null);
      selectElement(activeElement, panelLocation);
    }
  };

  return jsx(React.Fragment, null, jsx(MoveableWrapper, {
    isEditable: !isElementLocked(isFullBleedBackground),
    isSelected: editing === 'fullbleed' ? true : element.isSelected,
    size: {
      width: width,
      height: height
    },
    position: {
      x: x,
      y: y,
      z: z
    },
    parentWidth: panelSize.width,
    parentHeight: panelSize.height,
    parentId: "" + activeElement.location + panelLocation,
    elementLocation: (activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) || 0,
    onUpdatePosition: handleUpdatePosition,
    onUpdateRotation: updateElementRotation,
    onUpdateSize: handleUpdateSize,
    rotation: rotation,
    onActiveElementDelete: function () {
      return removeElement();
    },
    onActiveElementReplace: function (shouldReplaceSelectedImage) {
      openElementInsertDrawer('images');
      setShouldReplaceSelectedImage(shouldReplaceSelectedImage);
    },
    onActiveElementDrag: function () {
      activeElement.type === 'image' ? setActiveImageSetting(null) : setActiveTextSetting(null);
    },
    elementType: activeElement.type,
    shouldReplaceSelectedImage: shouldReplaceSelectedImage
  }, jsx("div", {
    onClick: function (event) {
      return handleElementOnClick(event, isFullBleedBackground);
    },
    id: elementId,
    className: 'elementContainer',
    css: styles.elementContainer(props, success.base, grayScale.base),
    onMouseDown: function () {
      if (canElementBeSelected(isFullBleedBackground)) {
        if (isFullBleedBackground) {
          return;
        }

        handleSelectElement(activeElement, panelLocation);
      }
    }
  }, children)));
};

var Element$1 = connect(function (_a) {
  var editor = _a.editor,
      editorChrome = _a.editorChrome;
  return {
    activeElementLocation: editor.activeElement.location,
    canSelectElements: editor.canSelectElements,
    activeImageSetting: editorChrome.activeImageSetting,
    activeTextSetting: editorChrome.activeTextSetting,
    elementSettingsDrawerType: editorChrome.elementSettingsDrawerType,
    editing: editor.editing,
    shouldReplaceSelectedImage: editorChrome.shouldReplaceSelectedImage
  };
}, {
  selectElement: selectElement,
  updateElementPosition: updateElementPosition,
  updateElementSize: updateElementSize,
  toggleElementDraggable: toggleElementDraggable,
  enableSelectingElements: enableSelectingElements,
  updateFullBleedBackgroundElementPosition: updateFullBleedBackgroundElementPosition,
  updateFullBleedBackgroundElementSize: updateFullBleedBackgroundElementSize,
  updateElementRotation: updateElementRotation,
  setShouldReplaceSelectedImage: setShouldReplaceSelectedImage,
  removeElement: removeElement,
  setActiveImageSetting: setActiveImageSetting,
  setActiveTextSetting: setActiveTextSetting,
  openElementInsertDrawer: openElementInsertDrawer
})(Element);

var EmptyImage = function (_a) {
  var title = _a.title,
      type = _a.type;
  return jsx(VStack, {
    gap: "x1_5"
  }, jsx(IconLink, {
    onClick: function () {},
    size: type === 'element' ? 'xSmall' : 'medium',
    activeColor: "primaryHeadingText",
    icon: "image",
    isStacked: true,
    isActive: true
  }), jsx(Text, {
    type: type === 'element' ? 'footnote' : 'body',
    alignment: "center"
  }, title));
};

var ImageElement =
/** @class */
function (_super) {
  __extends(ImageElement, _super);

  function ImageElement(props) {
    var _this = _super.call(this, props) || this;

    _this.isUserImage = function (photoUrl) {
      return photoUrl && photoUrl.indexOf('user_images') > -1;
    };

    _this.photoUrl = function (element) {
      var image = element.image && element.image.image;

      if (!image || !image.url) {
        return '';
      }

      return image.url;
    };

    var image = props.element.image;
    _this.state = {
      isLoaded: !!(image && image.image && imageIsCached(image.image.url))
    };
    return _this;
  }

  ImageElement.prototype.componentDidUpdate = function (prevProps) {
    var element = prevProps.element;
    var image = element.image;
    var next = this.props.element.image;

    if (image && image.image && next && next.image && !imageIsCached(next.image.url) && image.image.url !== next.image.url // image.filter !== next.filter
    ) {
        this.setState({
          isLoaded: false
        });
      }
  };

  ImageElement.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        element = _a.element,
        panelLocation = _a.panelLocation,
        elementId = _a.elementId,
        _b = _a.isFullBleedBackground,
        isFullBleedBackground = _b === void 0 ? false : _b,
        panelSize = _a.panelSize,
        isPreview = _a.isPreview,
        selectImagePosition = _a.selectImagePosition,
        isPanelLocked = _a.isPanelLocked,
        activeImageSetting = _a.activeImageSetting,
        elementSettingsDrawerType = _a.elementSettingsDrawerType,
        openElementSettingsDrawer = _a.openElementSettingsDrawer,
        openElementInsertDrawer = _a.openElementInsertDrawer,
        updateFullBleedBackgroundImagePosition = _a.updateFullBleedBackgroundImagePosition;
    var isLoaded = this.state.isLoaded;
    var x = element.x,
        y = element.y,
        z = element.z,
        rotation = element.rotation,
        height = element.height,
        width = element.width,
        isSelected = element.isSelected;
    var image = element.image;
    var url = this.photoUrl(element);
    var showLoadingSpinner = !this.state.isLoaded && image && image.image;
    return jsx(Element$1, {
      x: x,
      y: y,
      z: z,
      rotation: rotation,
      height: height,
      width: width,
      elementId: elementId,
      element: element,
      panelLocation: panelLocation,
      panelIsLocked: isPanelLocked,
      showBorder: !!(image && !image.image && !isPreview) || !!image && image.scale < 1 || isSelected,
      panelSize: panelSize,
      nonDraggableSelector: '.nonDraggable',
      onEdit: function () {
        openElementSettingsDrawer(isFullBleedBackground ? 'fullbleed' : 'image');

        if (!element.draggable) {
          openElementInsertDrawer('images');
        }
      },
      isFullBleedBackground: isFullBleedBackground
    }, image && image.image ? jsx(AvatarEditor, {
      image: url,
      width: element.points.width,
      height: element.points.height,
      border: 0,
      scale: image.scale || 1,
      position: image.position,
      onPositionChange: activeImageSetting === 'crop' ? isFullBleedBackground ? function (position) {
        return updateFullBleedBackgroundImagePosition(position.x, position.y);
      } : function (position) {
        return selectImagePosition(position.x, position.y);
      } : function () {
        return null;
      },
      onImageReady: function () {
        return _this.setState({
          isLoaded: true
        });
      },
      style: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: isLoaded || !image.image ? 1 : 0,
        transition: 'opacity 500ms',
        zIndex: elementSettingsDrawerType === 'panel' ? 102 : 1
      }
    }) : jsx(EmptyImage, {
      title: "Add an Image",
      type: "element"
    }), showLoadingSpinner && jsx("div", {
      className: "center"
    }, jsx(LoadingSpinner, {
      size: "medium"
    })));
  };

  return ImageElement;
}(React.Component);

var ImageElement$1 = connect(function (state) {
  return {
    activeImageSetting: state.editorChrome.activeImageSetting,
    elementSettingsDrawerType: state.editorChrome.elementSettingsDrawerType
  };
}, {
  selectImagePosition: selectImagePosition,
  updateFullBleedBackgroundImagePosition: updateFullBleedBackgroundImagePosition,
  selectElement: selectElement,
  openElementSettingsDrawer: openElementSettingsDrawer,
  openElementInsertDrawer: openElementInsertDrawer
})(ImageElement);

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var styles$1 = {
  container: /*#__PURE__*/css({
    position: 'absolute',
    top: -36,
    border: "solid 1px pink",
    borderRadius: 15,
    padding: '4px 8px',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 3px 6px 0px rgba(0, 0, 0, .16)',
    cursor: 'default',
    '&:before': {
      content: '""',
      borderTop: "8px solid pink",
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      position: 'absolute',
      bottom: -8
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:container;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFZSIsImZpbGUiOiJzdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmV4cG9ydCB2YXIgc3R5bGVzID0ge1xyXG4gICAgY29udGFpbmVyOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxyXG4gICAgICAgIHRvcDogLTM2LFxyXG4gICAgICAgIGJvcmRlcjogXCJzb2xpZCAxcHggcGlua1wiLFxyXG4gICAgICAgIGJvcmRlclJhZGl1czogMTUsXHJcbiAgICAgICAgcGFkZGluZzogJzRweCA4cHgnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICBqdXN0aWZ5Q29udGVudDogJ2NlbnRlcicsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDNweCA2cHggMHB4IHJnYmEoMCwgMCwgMCwgLjE2KScsXHJcbiAgICAgICAgY3Vyc29yOiAnZGVmYXVsdCcsXHJcbiAgICAgICAgJyY6YmVmb3JlJzoge1xyXG4gICAgICAgICAgICBjb250ZW50OiAnXCJcIicsXHJcbiAgICAgICAgICAgIGJvcmRlclRvcDogXCI4cHggc29saWQgcGlua1wiLFxyXG4gICAgICAgICAgICBib3JkZXJMZWZ0OiAnOHB4IHNvbGlkIHRyYW5zcGFyZW50JyxcclxuICAgICAgICAgICAgYm9yZGVyUmlnaHQ6ICc4cHggc29saWQgdHJhbnNwYXJlbnQnLFxyXG4gICAgICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcclxuICAgICAgICAgICAgYm90dG9tOiAtOCxcclxuICAgICAgICB9LFxyXG4gICAgfSksXHJcbiAgICBtZXNzYWdlMTogY3NzKHtcclxuICAgICAgICBmb250U2l6ZTogMTIsXHJcbiAgICAgICAgY29sb3I6ICdibGFjaycsXHJcbiAgICAgICAgbWFyZ2luUmlnaHQ6IDMsXHJcbiAgICAgICAgZm9udFdlaWdodDogNzAwLFxyXG4gICAgfSksXHJcbiAgICBtZXNzYWdlMjogY3NzKHtcclxuICAgICAgICBmb250U2l6ZTogMTIsXHJcbiAgICAgICAgY29sb3I6ICdibGFjaycsXHJcbiAgICAgICAgZm9udFdlaWdodDogNTAwLFxyXG4gICAgfSksXHJcbn07XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlcy5qcy5tYXAiXX0= */"),
  message1: process.env.NODE_ENV === "production" ? {
    name: "12btejx",
    styles: "font-size:12px;color:black;margin-right:3px;font-weight:700"
  } : {
    name: "1eqakc6-message1",
    styles: "font-size:12px;color:black;margin-right:3px;font-weight:700;label:message1;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFxQmMiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgdmFyIHN0eWxlcyA9IHtcclxuICAgIGNvbnRhaW5lcjogY3NzKHtcclxuICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcclxuICAgICAgICB0b3A6IC0zNixcclxuICAgICAgICBib3JkZXI6IFwic29saWQgMXB4IHBpbmtcIixcclxuICAgICAgICBib3JkZXJSYWRpdXM6IDE1LFxyXG4gICAgICAgIHBhZGRpbmc6ICc0cHggOHB4JyxcclxuICAgICAgICBkaXNwbGF5OiAnZmxleCcsXHJcbiAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxyXG4gICAgICAgIGJveFNoYWRvdzogJzBweCAzcHggNnB4IDBweCByZ2JhKDAsIDAsIDAsIC4xNiknLFxyXG4gICAgICAgIGN1cnNvcjogJ2RlZmF1bHQnLFxyXG4gICAgICAgICcmOmJlZm9yZSc6IHtcclxuICAgICAgICAgICAgY29udGVudDogJ1wiXCInLFxyXG4gICAgICAgICAgICBib3JkZXJUb3A6IFwiOHB4IHNvbGlkIHBpbmtcIixcclxuICAgICAgICAgICAgYm9yZGVyTGVmdDogJzhweCBzb2xpZCB0cmFuc3BhcmVudCcsXHJcbiAgICAgICAgICAgIGJvcmRlclJpZ2h0OiAnOHB4IHNvbGlkIHRyYW5zcGFyZW50JyxcclxuICAgICAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXHJcbiAgICAgICAgICAgIGJvdHRvbTogLTgsXHJcbiAgICAgICAgfSxcclxuICAgIH0pLFxyXG4gICAgbWVzc2FnZTE6IGNzcyh7XHJcbiAgICAgICAgZm9udFNpemU6IDEyLFxyXG4gICAgICAgIGNvbG9yOiAnYmxhY2snLFxyXG4gICAgICAgIG1hcmdpblJpZ2h0OiAzLFxyXG4gICAgICAgIGZvbnRXZWlnaHQ6IDcwMCxcclxuICAgIH0pLFxyXG4gICAgbWVzc2FnZTI6IGNzcyh7XHJcbiAgICAgICAgZm9udFNpemU6IDEyLFxyXG4gICAgICAgIGNvbG9yOiAnYmxhY2snLFxyXG4gICAgICAgIGZvbnRXZWlnaHQ6IDUwMCxcclxuICAgIH0pLFxyXG59O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
  },
  message2: process.env.NODE_ENV === "production" ? {
    name: "1w1ahc4",
    styles: "font-size:12px;color:black;font-weight:500"
  } : {
    name: "1uax2s8-message2",
    styles: "font-size:12px;color:black;font-weight:500;label:message2;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyQmMiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgdmFyIHN0eWxlcyA9IHtcclxuICAgIGNvbnRhaW5lcjogY3NzKHtcclxuICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcclxuICAgICAgICB0b3A6IC0zNixcclxuICAgICAgICBib3JkZXI6IFwic29saWQgMXB4IHBpbmtcIixcclxuICAgICAgICBib3JkZXJSYWRpdXM6IDE1LFxyXG4gICAgICAgIHBhZGRpbmc6ICc0cHggOHB4JyxcclxuICAgICAgICBkaXNwbGF5OiAnZmxleCcsXHJcbiAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxyXG4gICAgICAgIGJveFNoYWRvdzogJzBweCAzcHggNnB4IDBweCByZ2JhKDAsIDAsIDAsIC4xNiknLFxyXG4gICAgICAgIGN1cnNvcjogJ2RlZmF1bHQnLFxyXG4gICAgICAgICcmOmJlZm9yZSc6IHtcclxuICAgICAgICAgICAgY29udGVudDogJ1wiXCInLFxyXG4gICAgICAgICAgICBib3JkZXJUb3A6IFwiOHB4IHNvbGlkIHBpbmtcIixcclxuICAgICAgICAgICAgYm9yZGVyTGVmdDogJzhweCBzb2xpZCB0cmFuc3BhcmVudCcsXHJcbiAgICAgICAgICAgIGJvcmRlclJpZ2h0OiAnOHB4IHNvbGlkIHRyYW5zcGFyZW50JyxcclxuICAgICAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXHJcbiAgICAgICAgICAgIGJvdHRvbTogLTgsXHJcbiAgICAgICAgfSxcclxuICAgIH0pLFxyXG4gICAgbWVzc2FnZTE6IGNzcyh7XHJcbiAgICAgICAgZm9udFNpemU6IDEyLFxyXG4gICAgICAgIGNvbG9yOiAnYmxhY2snLFxyXG4gICAgICAgIG1hcmdpblJpZ2h0OiAzLFxyXG4gICAgICAgIGZvbnRXZWlnaHQ6IDcwMCxcclxuICAgIH0pLFxyXG4gICAgbWVzc2FnZTI6IGNzcyh7XHJcbiAgICAgICAgZm9udFNpemU6IDEyLFxyXG4gICAgICAgIGNvbG9yOiAnYmxhY2snLFxyXG4gICAgICAgIGZvbnRXZWlnaHQ6IDUwMCxcclxuICAgIH0pLFxyXG59O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZXMuanMubWFwIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
  }
};

var PillTip = function (props) {
  var message1 = props.message1,
      message2 = props.message2;
  return jsx("div", {
    css: styles$1.container
  }, jsx("span", {
    css: styles$1.message1
  }, message1), jsx("span", {
    css: styles$1.message2
  }, message2));
};

var styles$2 = {
  paragraph: function (paragraph, scale) {
    return __assign({
      fontFamily: paragraph.fontFamily,
      fontSize: paragraph.fontSize * scale || 12,
      color: rgbString(paragraph.color),
      textAlign: paragraph.textAlign.toLowerCase(),
      margin: '0'
    }, !!paragraph.fragments && {
      minHeight: paragraph.fontSize * scale || 12
    });
  },
  span: function (fragment, scale) {
    return {
      fontFamily: fragment.signatureFontFamily ? fragment.signatureFontFamily : fragment.fontFamily,
      fontSize: fragment.fontSize * scale,
      color: rgbString(fragment.color),
      textDecoration: fragment.text && fragment.text.length > 1 ? 'underline' : 'none',
      cursor: 'text'
    };
  }
};

var fragmentsFormat = 'application/vnd.sendoutcards.textfragments+json';

var selectionIndex = function (node, offset, isStart, selectionUpperBound) {
  if (node.nodeName === '#text') {
    var spanIndex = parseInt(node.parentElement && node.parentElement.dataset.index || '1', 10);

    if (offset === 0) {
      return spanIndex;
    } else if (offset === (node.textContent && node.textContent.length)) {
      return spanIndex + 1;
    } else {
      return isStart ? spanIndex : spanIndex + 1;
    }
  } else if (node.nodeName === 'P' && node instanceof HTMLElement) {
    return parseInt(node.dataset.index || '1', 10) + offset + 1;
  } else {
    return isStart ? 1 : selectionUpperBound;
  }
};

var TextEditor = function (props) {
  var _a = useResizeObserver(),
      ref = _a.ref,
      height = _a.height;

  var textEditorRef = useRef(null);
  var previousHeight = usePrevious(height);
  var _b = props.elementText,
      paragraphs = _b.paragraphs,
      selectionUpperBound = _b.selectionUpperBound,
      selection = _b.selection,
      selectText = props.selectText,
      scale = props.scale,
      insertCharacter = props.insertCharacter,
      insertText = props.insertText,
      insertFragments = props.insertFragments,
      insertNewLine = props.insertNewLine,
      deleteFragments = props.deleteFragments,
      deleteForwardFragments = props.deleteForwardFragments,
      panelSize = props.panelSize,
      updateElementSize = props.updateElementSize,
      elementProperties = props.elementProperties,
      activeElement = props.activeElement;

  var getHeightPercentage = function (height) {
    return height / panelSize.height;
  };

  var hasHeightReachedElementBounds = function (height) {
    return getHeightPercentage(height) >= elementProperties.height;
  };

  var hasHeightReachedPanelBounds = function () {
    return elementProperties.height + elementProperties.y >= 1;
  };

  var handleUpdateElementSize = function (height) {
    updateElementSize((activeElement === null || activeElement === void 0 ? void 0 : activeElement.location) || 0, elementProperties.width, height);
  };

  useEffect(function () {
    if (hasHeightReachedPanelBounds()) {
      return;
    }

    if (previousHeight && height && height !== previousHeight) {
      if (hasHeightReachedElementBounds(height)) {
        var delta = getHeightPercentage(height) - getHeightPercentage(previousHeight);
        var newHeight = delta + elementProperties.height + elementProperties.y >= 1 ? 1 - elementProperties.y : getHeightPercentage(height);
        handleUpdateElementSize(newHeight);
      }
    }
  }, [height]); //eslint-disable-line

  useEffect(function () {
    var selection = props.elementText.selection;

    if (!selection || !ref) {
      return;
    }

    if (textEditorRef.current) {
      var startNode = textEditorRef.current.childNodes[selection.start.paragraph];
      var endNode = textEditorRef.current.childNodes[selection.end.paragraph];

      if (!startNode || !endNode) {
        return;
      }

      var range = document.createRange();
      range.setStart(startNode, selection.start.offset);
      range.setEnd(endNode, selection.end.offset);
      var windowSelection = window.getSelection();

      if (windowSelection) {
        windowSelection.removeAllRanges();
        windowSelection.addRange(range);
      }
    }
  });

  var copy = function (event) {
    if (!selection) {
      return;
    }

    event.preventDefault();
    event.clipboardData.setData('text', selection.text);
    event.clipboardData.setData(fragmentsFormat, JSON.stringify(selection.fragments));
  };

  return jsx("div", {
    id: 'text_editor',
    ref: useMergeRefs([textEditorRef, ref]),
    autoCapitalize: "off",
    autoCorrect: "off",
    style: {
      whiteSpace: 'pre-wrap',
      outline: '0px',
      width: '100%'
    },
    onClick: function (event) {
      return event.stopPropagation();
    },
    onCut: function (event) {
      copy(event);
      deleteFragments();
    },
    onCopy: copy,
    onPaste: function (event) {
      event.preventDefault();
      var fragments = event.clipboardData.getData(fragmentsFormat);
      var text = event.clipboardData.getData('text');

      if (fragments) {
        insertFragments(JSON.parse(fragments));
      } else if (text) {
        insertText(text);
      }
    },
    onKeyDown: function (event) {
      if (event.key === 'Backspace') {
        event.preventDefault();
        deleteFragments();
      } else if (event.key === 'Delete') {
        event.preventDefault();
        deleteForwardFragments();
      } else if (event.key === 'Enter') {
        event.preventDefault();
        insertNewLine();
      }
    },
    onKeyPress: function (event) {
      if (event.nativeEvent.metaKey || event.nativeEvent.ctrlKey) {
        return;
      }

      event.preventDefault();
      insertCharacter(event.nativeEvent.key);
    },
    onSelect: function () {
      var windowSelection = window.getSelection();

      if (windowSelection) {
        var range = windowSelection.getRangeAt(0);
        var start = selectionIndex(range.startContainer, range.startOffset, true, selectionUpperBound);
        var end = selectionIndex(range.endContainer, range.endOffset, false, selectionUpperBound);

        if (!selection || selection.start.index !== start || selection.end.index !== end) {
          selectText(start, end);
        }
      }
    },
    contentEditable: true,
    suppressContentEditableWarning: true
  }, paragraphs.map(function (paragraph) {
    return jsx("p", {
      key: paragraph.index,
      "data-index": paragraph.index,
      css: function () {
        return styles$2.paragraph(paragraph, scale);
      }
    }, paragraph.fragments.map(function (fragment) {
      return jsx("span", {
        key: fragment.index,
        "data-index": fragment.index,
        css: function () {
          return styles$2.span(fragment, scale);
        }
      }, fragment.text ? fragment.text : signatureCharacter);
    }));
  }));
};

var TextEditor$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    activeElement: editor.activeElement
  };
}, {
  insertCharacter: insertCharacter,
  insertText: insertText,
  insertFragments: insertFragments,
  insertNewLine: insertNewLine,
  deleteFragments: deleteFragments,
  deleteForwardFragments: deleteForwardFragments,
  updateElementSize: updateElementSize
})(TextEditor);

var styles$3 = {
  contents: {
    height: '100%',
    width: '100%',
    overflow: 'auto'
  }
};

var TextElement = function (props) {
  var element = props.element,
      elementId = props.elementId,
      panelLocation = props.panelLocation,
      panelSize = props.panelSize,
      scaledPanelWidth = props.scaledPanelWidth,
      selectElement = props.selectElement,
      isPanelLocked = props.isPanelLocked,
      openElementSettingsDrawer = props.openElementSettingsDrawer,
      closeElementInsertDrawer = props.closeElementInsertDrawer;
  var x = element.x,
      y = element.y,
      z = element.z,
      rotation = element.rotation,
      height = element.height,
      width = element.width;

  var selectText = function (start, end) {
    return selectElement({
      location: element.location,
      type: 'text'
    }, panelLocation, start, end ? end : start);
  };

  var selectTextElement = function () {
    if (element.text) {
      selectText(element.text.selectionUpperBound);
    }
  };

  var hasNoTextInElement = !!(element.text && element.text.paragraphs.length === 1 && element.text.paragraphs[0].fragments.length === 0);
  var textScale = panelSize.width / scaledPanelWidth;
  return jsx(Element$1, {
    x: x,
    y: y,
    z: z,
    rotation: rotation,
    height: height,
    width: width,
    elementId: elementId,
    showBorder: element.isSelected || hasNoTextInElement,
    panelSize: panelSize,
    panelIsLocked: isPanelLocked,
    element: element,
    panelLocation: panelLocation,
    onEdit: function () {
      selectTextElement();
      openElementSettingsDrawer(panelLocation === null ? 'panel' : 'text');
      closeElementInsertDrawer();
    }
  }, jsx("div", {
    css: styles$3.contents
  }, jsx(React.Fragment, null, element.text && jsx(TextEditor$1, {
    elementProperties: {
      width: width,
      height: height,
      x: x,
      y: y,
      z: z
    },
    elementText: element.text,
    selectText: selectText,
    scale: textScale,
    panelSize: panelSize
  }))));
};

var TextElement$1 = connect(null, {
  selectElement: selectElement,
  openElementSettingsDrawer: openElementSettingsDrawer,
  closeElementInsertDrawer: closeElementInsertDrawer
})(TextElement);

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var styles$4 = {
  fullbleedPanel: process.env.NODE_ENV === "production" ? {
    name: "1cjuka5",
    styles: "background:transparent;box-shadow:0 8px 22px 0 rgba(0, 0, 0, 0.175);width:100%;height:100%;cursor:default;z-index:4"
  } : {
    name: "16bxou2-fullbleedPanel",
    styles: "background:transparent;box-shadow:0 8px 22px 0 rgba(0, 0, 0, 0.175);width:100%;height:100%;cursor:default;z-index:4;label:fullbleedPanel;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
  },
  panelContainer: function (props, panelView, isPreview) {
    return /*#__PURE__*/css(__assign(__assign({}, styles$4.fullbleedPanel), {
      display: 'flex',
      justifyContent: 'center',
      width: panelView === 'fullbleed' ? props.panel.width * 100 + "%" : '100%',
      height: panelView === 'fullbleed' ? props.panel.height * 100 + "%" : '100%',
      position: 'relative',
      zIndex: props.isActivePanel && !isPreview ? 100 : 3,
      '&::after': props.isActivePanel && !isPreview ? {
        content: '""',
        position: 'absolute',
        top: -3,
        left: -3,
        width: 'calc(100% + 6px)',
        height: 'calc(100% + 6px)',
        background: 'blue'
      } : {}
    }), process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  },
  panelContents: function (isEditingFullBleed, isSelected, activeColor) {
    return /*#__PURE__*/css({
      cursor: isEditingFullBleed ? 'default' : 'pointer',
      position: 'relative',
      height: '100%',
      width: '100%',
      // backgroundColor: '#ffffff',
      border: "2px solid " + (isSelected ? activeColor : 'transparent'),
      zIndex: 3
    }, process.env.NODE_ENV === "production" ? "" : ";label:styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
  }
};

var getElementId = function (editorId, panelIndex, elementIndex) {
  return "editor_" + editorId + "_panel_" + panelIndex + "_element_" + elementIndex;
};

var Panel = function (props) {
  var panel = props.panel,
      panelIndex = props.panelIndex,
      scaledPanelWidth = props.scaledPanelWidth,
      onSelectPanel = props.onSelectPanel,
      // showEditPanelButton,
  // selectElement,
  // canSelectElements,
  isPanelLabelHidden = props.isPanelLabelHidden,
      editing = props.editing,
      openElementSettingsDrawer = props.openElementSettingsDrawer;
  var isEditingFullBleed = editing === 'fullbleed';

  var handleSelectPanel = function (event, location) {
    var target = event.target;

    if (target.id !== 'panel-content') {
      return;
    }

    if (isEditingFullBleed) {
      return;
    }

    onSelectPanel(location); // Editor Chrome Actions

    openElementSettingsDrawer('panel');
  };

  var _a = useContext(EditorContext),
      isPreview = _a.isPreview,
      panelView = _a.panelView,
      editorId = _a.editorId;

  var success = useColorSwatch().success;
  var isPanelSelected = panel.isSelected;
  return jsx("div", {
    id: "editor_" + editorId + "_panel_" + panelIndex,
    css: styles$4.panelContainer(props, panelView, isPreview),
    onMouseDown: function (event) {
      return handleSelectPanel(event, panel.location);
    }
  }, (panel.isSelected || isPreview) && !isPanelLabelHidden && !isEditingFullBleed && jsx(PillTip, {
    message1: 'Location:',
    message2: panel.name
  }), jsx(ReactResizeDetector, {
    handleHeight: true,
    handleWidth: true,
    render: function (_a) {
      var width = _a.width,
          height = _a.height;
      return jsx("div", {
        id: "panel-content",
        css: [styles$4.panelContents(isEditingFullBleed, isPanelSelected, success.base), {
          backgroundColor: panel.backgroundColor ? rgbString(panel.backgroundColor) : undefined
        }, process.env.NODE_ENV === "production" ? "" : ";label:Panel;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
      }, panel.elements.length > 0 || isPreview ? panel.elements.map(function (element, index) {
        return jsx(React.Fragment, {
          key: index
        }, element.text && jsx(TextElement$1, {
          elementId: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          panelSize: {
            width: width,
            height: height
          },
          scaledPanelWidth: scaledPanelWidth,
          isPreview: isPreview,
          fullPanelElement: false,
          isPanelLocked: panel.isLocked
        }), element.image && jsx(ImageElement$1, {
          elementId: getElementId(editorId, panelIndex, element.location),
          element: element,
          panelLocation: panel.location,
          isPanelLocked: panel.isLocked,
          panelSize: {
            width: width,
            height: height
          },
          isPreview: false
        }));
      }) : jsx(React.Fragment, null));
    }
  }));
};

var Panel$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    canSelectElements: editor.canSelectElements,
    editing: editor.editing
  };
}, {
  selectElement: selectElement,
  openElementSettingsDrawer: openElementSettingsDrawer
})(Panel);

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var styles$5 = {
  fullbleedContainer: process.env.NODE_ENV === "production" ? {
    name: "1nxtnvz",
    styles: "position:relative;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);background:#FFF"
  } : {
    name: "urvcuy-fullbleedContainer",
    styles: "position:relative;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.08);background:#FFF;label:fullbleedContainer;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFd0IiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgfSksXHJcbn07XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlcy5qcy5tYXAiXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
  },
  fullbleedPanels: process.env.NODE_ENV === "production" ? {
    name: "19r0v6o",
    styles: "position:relative;display:flex;width:100%;height:100%"
  } : {
    name: "3b3f1w-fullbleedPanels",
    styles: "position:relative;display:flex;width:100%;height:100%;label:fullbleedPanels;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPcUIiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5leHBvcnQgZGVmYXVsdCB7XHJcbiAgICBmdWxsYmxlZWRDb250YWluZXI6IGNzcyh7XHJcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXHJcbiAgICAgICAgYm94U2hhZG93OiAnMHB4IDJweCA0cHggMHB4IHJnYmEoMCwwLDAsMC4wOCknLFxyXG4gICAgICAgIGJhY2tncm91bmQ6ICcjRkZGJyxcclxuICAgIH0pLFxyXG4gICAgZnVsbGJsZWVkUGFuZWxzOiBjc3Moe1xyXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxyXG4gICAgICAgIGRpc3BsYXk6ICdmbGV4JyxcclxuICAgICAgICB3aWR0aDogJzEwMCUnLFxyXG4gICAgICAgIGhlaWdodDogJzEwMCUnLFxyXG4gICAgfSksXHJcbn07XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlcy5qcy5tYXAiXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
  }
};

var CircleIconButton = function (_a) {
  var icon = _a.icon,
      onClick = _a.onClick,
      size = _a.size,
      iconSize = _a.iconSize,
      offsetButton = _a.offsetButton,
      offsetIcon = _a.offsetIcon;
  return jsx(Flex, {
    onClick: onClick,
    width: size || '50px',
    height: size || '50px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'foreground',
    borderRadius: 'circle',
    boxShadow: 'mediumLight',
    position: 'absolute',
    top: '50%',
    right: (offsetButton === null || offsetButton === void 0 ? void 0 : offsetButton.right) ? offsetButton.right : 0,
    left: (offsetButton === null || offsetButton === void 0 ? void 0 : offsetButton.left) ? offsetButton.left : 0,
    transform: 'translateY(-50%)',
    inset: (offsetIcon === null || offsetIcon === void 0 ? void 0 : offsetIcon.insetLeft) ? {
      left: offsetIcon.insetLeft
    } : (offsetIcon === null || offsetIcon === void 0 ? void 0 : offsetIcon.insetRight) ? {
      right: offsetIcon.insetRight
    } : 'x0',
    cursor: 'pointer'
  }, jsx(Icon, {
    name: icon,
    size: iconSize || 'medium',
    primaryColor: 'primaryBodyText'
  }));
};

var FullBleed = function (_a) {
  var activePanel = _a.activePanel,
      isHorizontal = _a.isHorizontal,
      onSelectPanel = _a.onSelectPanel,
      fullBleed = _a.fullBleed,
      hidePanelLabel = _a.hidePanelLabel,
      handleNextPanel = _a.handleNextPanel,
      handlePreviousPanel = _a.handlePreviousPanel,
      editing = _a.editing,
      openElementInsertDrawer = _a.openElementInsertDrawer;
  var fbHeight = fullBleed.height,
      fbWidth = fullBleed.width,
      panels = fullBleed.panels,
      backgroundElement = fullBleed.backgroundElement;
  var panelView = useContext(EditorContext).panelView;
  var width = panelView === 'fullbleed' ? fbWidth : panels[0].width * fbWidth;
  var height = panelView === 'fullbleed' ? fbHeight : panels[0].height * fbHeight;
  return jsx(ReactResizeDetector, {
    handleHeight: true,
    handleWidth: true
  }, function (_a) {
    var _b;

    var parentWidth = _a.width,
        parentHeight = _a.height;
    var heightMax = {
      height: parentHeight || 0,
      width: parentHeight / height * width || 0
    };
    var widthMax = {
      width: parentWidth || 0,
      height: parentWidth / width * height || 0
    };
    var isHeightWithinBounds = heightMax.height <= parentHeight && heightMax.width <= parentWidth;
    var isWidthWithinBounds = widthMax.height <= parentHeight && widthMax.width <= parentWidth;
    var heightArea = heightMax.height * heightMax.width;
    var widthArea = widthMax.height * widthMax.width;
    var hasReachedLimitHeight = isHeightWithinBounds && isWidthWithinBounds ? heightArea > widthArea : isHeightWithinBounds;
    return jsx("div", {
      id: 'fullbleed',
      css: [styles$5.fullbleedContainer, __assign({}, hasReachedLimitHeight ? heightMax : widthMax), process.env.NODE_ENV === "production" ? "" : ";label:FullBleed;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
    }, editing !== 'fullbleed' && jsx(CircleIconButton, {
      icon: 'leftChevron',
      offsetIcon: {
        insetRight: 'x_5'
      },
      offsetButton: {
        left: '-156px'
      },
      onClick: handlePreviousPanel
    }), jsx("div", {
      css: [styles$5.fullbleedPanels, {
        flexDirection: isHorizontal ? 'row' : 'column'
      }, process.env.NODE_ENV === "production" ? "" : ";label:FullBleed;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
    }, editing === 'fullbleed' && !((_b = backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) === null || _b === void 0 ? void 0 : _b.image) && jsx(Flex, {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      onClick: function () {
        return openElementInsertDrawer('images');
      },
      cursor: "pointer"
    }, jsx(EmptyImage, {
      type: "fullbleed",
      title: "Add full background image"
    })), (backgroundElement === null || backgroundElement === void 0 ? void 0 : backgroundElement.image) && jsx(ImageElement$1, {
      elementId: 'backgroundImage',
      element: backgroundElement,
      panelLocation: null,
      isFullBleedBackground: true,
      panelSize: hasReachedLimitHeight ? heightMax : widthMax,
      isPreview: false,
      isPanelLocked: false
    }), editing !== 'fullbleed' && panels.map(function (panel) {
      return jsx(Panel$1, {
        isPanelLabelHidden: hidePanelLabel,
        key: panel.location,
        panel: panel,
        panelIndex: panel.location,
        scaledPanelWidth: fullBleed.width * panel.width,
        onSelectPanel: onSelectPanel,
        isActivePanel: activePanel === panel.location
      });
    })), editing !== 'fullbleed' && jsx(CircleIconButton, {
      icon: 'rightChevron',
      offsetIcon: {
        insetLeft: 'x_5'
      },
      offsetButton: {
        right: '-156px'
      },
      onClick: handleNextPanel
    }));
  });
};

var FullBleed$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    numFullBleeds: editor.card ? editor.card.fullBleeds.length : 0,
    editing: editor.editing
  };
}, {
  openElementInsertDrawer: openElementInsertDrawer
})(FullBleed);

var Editor = function (_a) {
  var card = _a.card,
      fullBleeds = _a.fullBleeds,
      reduxCard = _a.reduxCard,
      isHorizontal = _a.isHorizontal,
      onSave = _a.onSave,
      // onSelectLayout,
  // onUploadImages,
  activeFullBleedLocation = _a.activeFullBleedLocation,
      activePanelLocation = _a.activePanelLocation,
      panels = _a.panels,
      selectPanel = _a.selectPanel,
      loadedCard = _a.loadedCard,
      resetState = _a.resetState,
      selectFullBleed = _a.selectFullBleed,
      panelLocations = _a.panelLocations,
      selectSinglePanel = _a.selectSinglePanel,
      panelView = _a.panelView,
      currentIndex = _a.currentIndex,
      handleNextPanel = _a.handleNextPanel,
      handlePreviousPanel = _a.handlePreviousPanel,
      openElementSettingsDrawer = _a.openElementSettingsDrawer;
  var id = Date.now();
  var previousReduxCard = usePrevious(reduxCard);
  var selectedFullBleed = panelView === 'fullbleed' && fullBleeds ? fullBleeds[activeFullBleedLocation] : panels ? panels[currentIndex] : null;
  var context = {
    currentIndex: currentIndex,
    panelView: panelView,
    editorId: id,
    isPreview: false
  };
  var hasHorizontalAspectRatio = selectedFullBleed ? isHorizontalFullBleed(panelView, activeFullBleedLocation, card.fullBleeds.length, selectedFullBleed.panels.length, isHorizontal) : false;

  var handleSelectPanel = function () {
    if (panelView === 'fullbleed') {
      selectFullBleed(currentIndex);
    } else {
      if (panelLocations && !!panelLocations.length) {
        var _a = panelLocations[currentIndex],
            fullbleed = _a.fullbleed,
            panel = _a.panel;
        selectSinglePanel(fullbleed, panel);
      }
    } // EditorChrome Actions


    openElementSettingsDrawer('panel');
  };

  useEffect(function () {
    if (reduxCard) {
      if (!equal(previousReduxCard, reduxCard)) {
        onSave(reduxCard);
      }
    }
  }, [reduxCard]); //eslint-disable-line

  useEffect(function () {
    if (card) {
      loadedCard(card);
      handleSelectPanel();
    }

    return function () {
      resetState();
    };
  }, [card]); //eslint-disable-line

  return reduxCard && selectedFullBleed ? jsx(EditorProvider, {
    value: context
  }, jsx(FullBleed$1, {
    activePanel: activePanelLocation,
    fullBleed: selectedFullBleed,
    isHorizontal: hasHorizontalAspectRatio,
    onSelectPanel: selectPanel,
    handleNextPanel: handleNextPanel,
    handlePreviousPanel: handlePreviousPanel
  })) : jsx(React.Fragment, null);
};

var Editor$1 = connect(function (_a) {
  var editor = _a.editor;
  return {
    activeFullBleedLocation: editor.fullBleedLocation,
    activePanelLocation: editor.panelLocation,
    isHorizontal: !!editor.card && editor.card.orientation === 'LANDSCAPE',
    fullBleeds: computedFullBleeds(editor),
    panels: editor.card && computedSingleFullBleeds(editor),
    reduxCard: editor.card,
    panelLocations: editor.card ? getPanelLocations(editor) : [],
    layoutToLoad: editor.layoutToLoad
  };
}, {
  loadedCard: loadedCard,
  resetState: resetState,
  selectFullBleed: selectFullBleed,
  selectLayout: selectLayout,
  selectPanel: selectPanel,
  selectSinglePanel: selectSinglePanel,
  openElementSettingsDrawer: openElementSettingsDrawer
}, null)(Editor);

var App = function (props) {
  var layouts = props.layouts,
      images = props.images,
      fonts = props.fonts,
      customFonts = props.customFonts,
      signatures = props.signatures,
      placeholders = props.placeholders,
      onUploadImages = props.onUploadImages,
      onSave = props.onSave,
      selectFullBleed = props.selectFullBleed,
      card = props.card,
      onSelectLayout = props.onSelectLayout,
      contextZones = props.contextZones,
      theme = props.theme;

  var _a = __read(React.useState('fullbleed'), 2),
      panelView = _a[0],
      setPanelView = _a[1];

  var _b = __read(React.useState(0), 2),
      currentIndex = _b[0],
      setCurrentIndex = _b[1];

  var lastPanel = card.fullBleeds.length - 1;

  var handlePreviousPanel = function () {
    var prev = currentIndex - 1;
    setCurrentIndex(prev >= 0 ? prev : lastPanel);
    selectFullBleed(prev >= 0 ? prev : lastPanel);
  };

  var handleNextPanel = function () {
    var next = currentIndex + 1;
    setCurrentIndex(next > lastPanel ? 0 : next);
    selectFullBleed(next > lastPanel ? 0 : next);
  };

  var handleChangeView = function () {
    setPanelView(panelView === 'fullbleed' ? 'panel' : 'fullbleed');
  };

  return jsx(React.Fragment, null, jsx(Global, {
    styles: [fonts.map(function (font) {
      return /*#__PURE__*/css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), font.fontName, font.ttfFile);
    }), customFonts === null || customFonts === void 0 ? void 0 : customFonts.map(function (font) {
      return /*#__PURE__*/css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFwcC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0NtQiIsImZpbGUiOiJBcHAudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgX19tYWtlVGVtcGxhdGVPYmplY3QsIF9fcmVhZCB9IGZyb20gXCJ0c2xpYlwiO1xyXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBHbG9iYWwsIGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0ICogYXMgYWN0aW9ucyBmcm9tIFwiLi4vcmVkdXgvZWRpdG9yL2FjdGlvbnNcIjtcclxuaW1wb3J0IEVkaXRvckNocm9tZSBmcm9tIFwiLi4vY29udGFpbmVycy9FZGl0b3JDaHJvbWUvRWRpdG9yQ2hyb21lXCI7XHJcbmltcG9ydCB7IERpdiwgSWNvbiB9IGZyb20gJ0BzZW5kb3V0Y2FyZHMvcXVhbnR1bS1kZXNpZ24tdWknO1xyXG5pbXBvcnQgRWRpdG9yIGZyb20gXCIuLi9jb250YWluZXJzL0VkaXRvci9FZGl0b3JcIjtcclxuaW1wb3J0IGNvbm5lY3QgZnJvbSBcIi4uL3JlZHV4L2Nvbm5lY3RcIjtcclxudmFyIEFwcCA9IGZ1bmN0aW9uIChwcm9wcykge1xyXG4gICAgdmFyIGxheW91dHMgPSBwcm9wcy5sYXlvdXRzLCBpbWFnZXMgPSBwcm9wcy5pbWFnZXMsIGZvbnRzID0gcHJvcHMuZm9udHMsIGN1c3RvbUZvbnRzID0gcHJvcHMuY3VzdG9tRm9udHMsIHNpZ25hdHVyZXMgPSBwcm9wcy5zaWduYXR1cmVzLCBwbGFjZWhvbGRlcnMgPSBwcm9wcy5wbGFjZWhvbGRlcnMsIG9uVXBsb2FkSW1hZ2VzID0gcHJvcHMub25VcGxvYWRJbWFnZXMsIG9uU2F2ZSA9IHByb3BzLm9uU2F2ZSwgc2VsZWN0RnVsbEJsZWVkID0gcHJvcHMuc2VsZWN0RnVsbEJsZWVkLCBjYXJkID0gcHJvcHMuY2FyZCwgb25TZWxlY3RMYXlvdXQgPSBwcm9wcy5vblNlbGVjdExheW91dCwgY29udGV4dFpvbmVzID0gcHJvcHMuY29udGV4dFpvbmVzLCB0aGVtZSA9IHByb3BzLnRoZW1lO1xyXG4gICAgdmFyIF9hID0gX19yZWFkKFJlYWN0LnVzZVN0YXRlKCdmdWxsYmxlZWQnKSwgMiksIHBhbmVsVmlldyA9IF9hWzBdLCBzZXRQYW5lbFZpZXcgPSBfYVsxXTtcclxuICAgIHZhciBfYiA9IF9fcmVhZChSZWFjdC51c2VTdGF0ZSgwKSwgMiksIGN1cnJlbnRJbmRleCA9IF9iWzBdLCBzZXRDdXJyZW50SW5kZXggPSBfYlsxXTtcclxuICAgIHZhciBsYXN0UGFuZWwgPSBjYXJkLmZ1bGxCbGVlZHMubGVuZ3RoIC0gMTtcclxuICAgIHZhciBoYW5kbGVQcmV2aW91c1BhbmVsID0gZnVuY3Rpb24gKCkge1xyXG4gICAgICAgIHZhciBwcmV2ID0gY3VycmVudEluZGV4IC0gMTtcclxuICAgICAgICBzZXRDdXJyZW50SW5kZXgocHJldiA+PSAwID8gcHJldiA6IGxhc3RQYW5lbCk7XHJcbiAgICAgICAgc2VsZWN0RnVsbEJsZWVkKHByZXYgPj0gMCA/IHByZXYgOiBsYXN0UGFuZWwpO1xyXG4gICAgfTtcclxuICAgIHZhciBoYW5kbGVOZXh0UGFuZWwgPSBmdW5jdGlvbiAoKSB7XHJcbiAgICAgICAgdmFyIG5leHQgPSBjdXJyZW50SW5kZXggKyAxO1xyXG4gICAgICAgIHNldEN1cnJlbnRJbmRleChuZXh0ID4gbGFzdFBhbmVsID8gMCA6IG5leHQpO1xyXG4gICAgICAgIHNlbGVjdEZ1bGxCbGVlZChuZXh0ID4gbGFzdFBhbmVsID8gMCA6IG5leHQpO1xyXG4gICAgfTtcclxuICAgIHZhciBoYW5kbGVDaGFuZ2VWaWV3ID0gZnVuY3Rpb24gKCkge1xyXG4gICAgICAgIHNldFBhbmVsVmlldyhwYW5lbFZpZXcgPT09ICdmdWxsYmxlZWQnID8gJ3BhbmVsJyA6ICdmdWxsYmxlZWQnKTtcclxuICAgIH07XHJcbiAgICByZXR1cm4gKDw+XG4gICAgICA8R2xvYmFsIHN0eWxlcz17W1xyXG4gICAgICAgIGZvbnRzLm1hcChmdW5jdGlvbiAoZm9udCkge1xyXG4gICAgICAgICAgICByZXR1cm4gY3NzKHRlbXBsYXRlT2JqZWN0XzEgfHwgKHRlbXBsYXRlT2JqZWN0XzEgPSBfX21ha2VUZW1wbGF0ZU9iamVjdChbXCJcXG4gICAgICAgICAgICAgIEBmb250LWZhY2Uge1xcbiAgICAgICAgICAgICAgICBmb250LWZhbWlseTogJ1wiLCBcIic7XFxuICAgICAgICAgICAgICAgIHNyYzogdXJsKCdcIiwgXCInKSBmb3JtYXQoJ3RydWV0eXBlJyk7XFxuICAgICAgICAgICAgICB9XFxuICAgICAgICAgICAgXCJdLCBbXCJcXG4gICAgICAgICAgICAgIEBmb250LWZhY2Uge1xcbiAgICAgICAgICAgICAgICBmb250LWZhbWlseTogJ1wiLCBcIic7XFxuICAgICAgICAgICAgICAgIHNyYzogdXJsKCdcIiwgXCInKSBmb3JtYXQoJ3RydWV0eXBlJyk7XFxuICAgICAgICAgICAgICB9XFxuICAgICAgICAgICAgXCJdKSksIGZvbnQuZm9udE5hbWUsIGZvbnQudHRmRmlsZSk7XHJcbiAgICAgICAgfSksXHJcbiAgICAgICAgY3VzdG9tRm9udHMgPT09IG51bGwgfHwgY3VzdG9tRm9udHMgPT09IHZvaWQgMCA/IHZvaWQgMCA6IGN1c3RvbUZvbnRzLm1hcChmdW5jdGlvbiAoZm9udCkge1xyXG4gICAgICAgICAgICByZXR1cm4gY3NzKHRlbXBsYXRlT2JqZWN0XzIgfHwgKHRlbXBsYXRlT2JqZWN0XzIgPSBfX21ha2VUZW1wbGF0ZU9iamVjdChbXCJcXG4gICAgICAgICAgICAgIEBmb250LWZhY2Uge1xcbiAgICAgICAgICAgICAgICBmb250LWZhbWlseTogJ1wiLCBcIic7XFxuICAgICAgICAgICAgICAgIHNyYzogdXJsKCdcIiwgXCInKSBmb3JtYXQoJ3RydWV0eXBlJyk7XFxuICAgICAgICAgICAgICB9XFxuICAgICAgICAgICAgXCJdLCBbXCJcXG4gICAgICAgICAgICAgIEBmb250LWZhY2Uge1xcbiAgICAgICAgICAgICAgICBmb250LWZhbWlseTogJ1wiLCBcIic7XFxuICAgICAgICAgICAgICAgIHNyYzogdXJsKCdcIiwgXCInKSBmb3JtYXQoJ3RydWV0eXBlJyk7XFxuICAgICAgICAgICAgICB9XFxuICAgICAgICAgICAgXCJdKSksIGZvbnQuZm9udE5hbWUsIGZvbnQudHRmRmlsZSk7XHJcbiAgICAgICAgfSksXHJcbiAgICAgICAgc2lnbmF0dXJlcyA9PT0gbnVsbCB8fCBzaWduYXR1cmVzID09PSB2b2lkIDAgPyB2b2lkIDAgOiBzaWduYXR1cmVzLm1hcChmdW5jdGlvbiAoc2lnbmF0dXJlKSB7XHJcbiAgICAgICAgICAgIHJldHVybiBjc3ModGVtcGxhdGVPYmplY3RfMyB8fCAodGVtcGxhdGVPYmplY3RfMyA9IF9fbWFrZVRlbXBsYXRlT2JqZWN0KFtcIlxcbiAgICAgICAgICAgICAgQGZvbnQtZmFjZSB7XFxuICAgICAgICAgICAgICAgIGZvbnQtZmFtaWx5OiAnXCIsIFwiJztcXG4gICAgICAgICAgICAgICAgc3JjOiB1cmwoJ1wiLCBcIicpIGZvcm1hdCgndHJ1ZXR5cGUnKTtcXG4gICAgICAgICAgICAgIH1cXG4gICAgICAgICAgICBcIl0sIFtcIlxcbiAgICAgICAgICAgICAgQGZvbnQtZmFjZSB7XFxuICAgICAgICAgICAgICAgIGZvbnQtZmFtaWx5OiAnXCIsIFwiJztcXG4gICAgICAgICAgICAgICAgc3JjOiB1cmwoJ1wiLCBcIicpIGZvcm1hdCgndHJ1ZXR5cGUnKTtcXG4gICAgICAgICAgICAgIH1cXG4gICAgICAgICAgICBcIl0pKSwgc2lnbmF0dXJlLmZvbnROYW1lLCBzaWduYXR1cmUudHRmRmlsZSk7XHJcbiAgICAgICAgfSksXHJcbiAgICBdfS8+XG4gICAgICA8RWRpdG9yQ2hyb21lIHRoZW1lPXt0aGVtZX0gY29udGV4dFpvbmVzPXtjb250ZXh0Wm9uZXN9IGxheW91dHM9e2xheW91dHN9IGltYWdlcz17aW1hZ2VzLnJlc3VsdHN9IGZvbnRzPXtmb250c30gY3VzdG9tRm9udHM9e2N1c3RvbUZvbnRzfSBzaWduYXR1cmVzPXtzaWduYXR1cmVzfSBwbGFjZWhvbGRlcnM9e3BsYWNlaG9sZGVyc30gaGFuZGxlQ2hhbmdlVmlldz17aGFuZGxlQ2hhbmdlVmlld30gb25VcGxvYWRJbWFnZXM9e29uVXBsb2FkSW1hZ2VzfSBcclxuICAgIC8vIGhhbmRsZVByZXZpZXc9e2hhbmRsZVByZXZpZXd9XHJcbiAgICBzY2FsZT17MTAwfSBoZWxwSWNvbj17PERpdiBpZD17J2ludGVyY29tX2J0bid9IGRpc3BsYXk9XCJmbGV4XCIganVzdGlmeUNvbnRlbnQ9XCJjZW50ZXJcIiBhbGlnbkl0ZW1zPVwiY2VudGVyXCIgaW5zZXQ9e3sgYm90dG9tOiAneDInIH19IGN1cnNvcj1cInBvaW50ZXJcIj5cbiAgICAgICAgICAgIDxJY29uIG5hbWU9XCJpbmZvcm1hdGlvblwiIHByaW1hcnlDb2xvcj1cInByaW1hcnlCcmFuZFwiIHNpemU9XCJtZWRpdW1cIi8+XG4gICAgICAgICAgPC9EaXY+fT5cbiAgICAgICAgPEVkaXRvciB7Li4ucHJvcHN9IG9uU2F2ZT17b25TYXZlfSBvblNlbGVjdExheW91dD17b25TZWxlY3RMYXlvdXR9IG9uVXBsb2FkSW1hZ2VzPXtvblVwbG9hZEltYWdlc30gY2FyZD17Y2FyZH0gaGFuZGxlTmV4dFBhbmVsPXtoYW5kbGVOZXh0UGFuZWx9IGhhbmRsZVByZXZpb3VzUGFuZWw9e2hhbmRsZVByZXZpb3VzUGFuZWx9IHBhbmVsVmlldz17cGFuZWxWaWV3fSBjdXJyZW50SW5kZXg9e2N1cnJlbnRJbmRleH0vPlxuICAgICAgPC9FZGl0b3JDaHJvbWU+XG4gICAgPC8+KTtcclxufTtcclxuZXhwb3J0IGRlZmF1bHQgY29ubmVjdChudWxsLCB7XHJcbiAgICBzZWxlY3RGdWxsQmxlZWQ6IGFjdGlvbnMuc2VsZWN0RnVsbEJsZWVkLFxyXG59LCBudWxsKShBcHApO1xyXG52YXIgdGVtcGxhdGVPYmplY3RfMSwgdGVtcGxhdGVPYmplY3RfMiwgdGVtcGxhdGVPYmplY3RfMztcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9QXBwLmpzeC5tYXAiXX0= */")])), font.fontName, font.ttfFile);
    }), signatures === null || signatures === void 0 ? void 0 : signatures.map(function (signature) {
      return /*#__PURE__*/css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")], ["\n              @font-face {\n                font-family: '", "';\n                src: url('", "') format('truetype');\n              }\n            " + (process.env.NODE_ENV === "production" ? "" : ";label:App;") + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")])), signature.fontName, signature.ttfFile);
    }), process.env.NODE_ENV === "production" ? "" : ";label:App;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
  }), jsx(EditorChrome$1, {
    theme: theme,
    contextZones: contextZones,
    layouts: layouts,
    images: images.results,
    fonts: fonts,
    customFonts: customFonts,
    signatures: signatures,
    placeholders: placeholders,
    handleChangeView: handleChangeView,
    onUploadImages: onUploadImages // handlePreview={handlePreview}
    ,
    scale: 100,
    helpIcon: jsx(Div, {
      id: 'intercom_btn',
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      inset: {
        bottom: 'x2'
      },
      cursor: "pointer"
    }, jsx(Icon, {
      name: "information",
      primaryColor: "primaryBrand",
      size: "medium"
    }))
  }, jsx(Editor$1, _extends_1({}, props, {
    onSave: onSave,
    onSelectLayout: onSelectLayout,
    onUploadImages: onUploadImages,
    card: card,
    handleNextPanel: handleNextPanel,
    handlePreviousPanel: handlePreviousPanel,
    panelView: panelView,
    currentIndex: currentIndex
  }))));
};

var App$1 = connect(null, {
  selectFullBleed: selectFullBleed
}, null)(App);
var templateObject_1$2, templateObject_2, templateObject_3;

var GlobalEditor = function (props) {
  var _a = __read(useState(Store()), 1),
      store = _a[0];

  return store && jsx(Provider, {
    store: store
  }, jsx(App$1, props));
};

export { GlobalEditor };
